<template>
  <div class="authdep-container">
    <!-- 背景装饰 -->
    <div class="leftSider">
      <img src="@assets/leftSider.png" alt="">
    </div>
    <div class="rightSider">
      <img src="@assets/rightSider.png" alt="">
    </div>

    <!-- Header -->
    <dp-header :title="'授权依赖风险监测'"></dp-header>

    <!-- 子页面 Tab 切换 -->
    <div class="sub-tabs">
      <div
        v-for="tab in tabs"
        :key="tab.value"
        class="sub-tab-item"
        :class="{ 'active': activeTab === tab.value }"
        @click="activeTab = tab.value"
      >
        {{ tab.label }}
      </div>
    </div>

    <!-- 主内容区 -->
    <div class="main-content">
      <!-- 子页面1：风险态势 -->
      <div v-if="activeTab === 'dashboard'" class="tab-panel">
        <!-- 顶部筛选 -->
        <div class="filter-bar section-card">
          <div class="filter-group">
            <span class="filter-label">数据源</span>
            <el-select v-model="dashFilter.source" size="small" class="filter-select">
              <el-option label="全部" value="all"></el-option>
              <el-option label="Tranco" value="tranco"></el-option>
              <el-option label="Secrank" value="secrank"></el-option>
              <el-option label="Cloudflare" value="cloudflare"></el-option>
              <el-option label="全球govedu" value="edugov"></el-option>
              <el-option label="国内重要机构" value="domestic"></el-option>
            </el-select>
          </div>
          <div class="filter-group">
            <span class="filter-label">统计维度</span>
            <el-select v-model="dashFilter.dimension" size="small" class="filter-select">
              <el-option label="全部" value="all"></el-option>
              <el-option label="主域名" value="main"></el-option>
              <el-option label="子域名" value="sub"></el-option>
            </el-select>
          </div>
          <div class="scan-time">最近一次扫描时间：<span class="highlight">{{ lastScanTime }}</span></div>
        </div>

        <!-- 三列看板 -->
        <div class="dashboard-panels">
          <!-- 核心指标看板 -->
          <div
            class="section-card panel-card"
            v-loading="coreMetricsLoading"
            element-loading-background="rgba(15, 23, 42, 0.6)"
          >
            <div class="card-title">核心指标看板</div>

            <!-- 4 个 KPI 数字 -->
            <div class="kpi-grid">
              <div class="kpi-item">
                <div class="kpi-value">{{ coreMetrics.totalDomains.toLocaleString() }}</div>
                <div class="kpi-label">监控域名总数</div>
              </div>
              <div class="kpi-item">
                <div class="kpi-value">{{ coreMetrics.takeoverTotal.toLocaleString() }}</div>
                <div class="kpi-label">域名接管风险</div>
              </div>
              <div class="kpi-item">
                <div class="kpi-value">{{ coreMetrics.dosTotal.toLocaleString() }}</div>
                <div class="kpi-label">拒绝服务风险</div>
              </div>
              <div class="kpi-item">
                <div class="kpi-value">{{ coreMetrics.avgDepth }}</div>
                <div class="kpi-label">平均依赖深度</div>
              </div>
            </div>

            <div class="kpi-divider"></div>

            <!-- list authorization overview -->
            <div class="dep-table-title" style="margin-top:0">各列表授权依赖概览</div>
            <el-table
              :data="listStatsTable"
              size="mini"
              class="dep-table"
              :row-class-name="listRowClass"
            >
              <el-table-column prop="friendlyName" label="列表" width="96"></el-table-column>
              <el-table-column label="域名数" min-width="85" align="left">
                <template slot-scope="scope">
                  {{ scope.row.count ? scope.row.count.toLocaleString() : '-' }}
                </template>
              </el-table-column>
              <el-table-column label="均值深度" min-width="76" align="left">
                <template slot-scope="scope">
                  {{ scope.row.avgDepth != null ? scope.row.avgDepth.toFixed(1) : '-' }}
                </template>
              </el-table-column>
              <el-table-column label="最大深度" min-width="76" align="left">
                <template slot-scope="scope">
                  {{ scope.row.avgMaxDepth != null ? scope.row.avgMaxDepth.toFixed(1) : '-' }}
                </template>
              </el-table-column>
            </el-table>



            <!-- scan task overview -->
            <div class="dep-table-title" style="margin-top:10px">扫描任务概况</div>
            <el-table
              :data="scanTaskRows"
              size="mini"
              class="dep-table"
            >
              <el-table-column prop="item" label="指标" min-width="120"></el-table-column>
              <el-table-column prop="value" label="数值" min-width="160" align="right"></el-table-column>
            </el-table>
          </div>

          <!-- 授权依赖风险看板 -->
          <div
            class="section-card panel-card"
            v-loading="riskStatsLoading"
            element-loading-background="rgba(15, 23, 42, 0.6)"
          >
            <div class="card-title">授权依赖风险看板</div>
            <div class="risk-stats-cards-container">
              <div v-for="(group, groupIdx) in riskGroups" :key="group.key" class="risk-stats-group-wrapper">
                <div v-if="groupIdx > 0" class="risk-stats-category-divider"></div>
                <div class="risk-stats-category-label">{{ group.label }}</div>
                <div
                  v-for="(item, idx) in group.items"
                  :key="group.key + '-' + idx"
                  class="risk-stats-card-item"
                  :class="'risk-group-' + group.key"
                >
                  <div class="risk-stats-card-header">
                    <span class="risk-stats-icon" :class="'icon-group-' + group.key">
                      <i :class="groupIconMap[group.key]"></i>
                    </span>
                    <el-tooltip
                      v-if="item.detail"
                      :content="item.detail"
                      placement="left"
                      :open-delay="200"
                      effect="dark"
                    >
                      <div class="risk-stats-name">{{ item.type }}</div>
                    </el-tooltip>
                    <div v-else class="risk-stats-name">{{ item.type }}</div>
                  </div>
                  <div class="risk-stats-card-body">
                    <div class="risk-stats-count-wrapper">
                      <div class="risk-stats-count">{{ item.domain.toLocaleString() }}</div>
                      <div class="risk-stats-unit">域名数</div>
                    </div>
                    <span class="risk-stats-badge">{{ group.label }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 授权依赖信息看板 -->
          <div
            class="section-card panel-card"
            v-loading="topNodesLoading"
            element-loading-background="rgba(15, 23, 42, 0.6)"
          >
            <div class="card-title">授权依赖信息看板</div>

            <!-- 关键依赖节点（按当前数据源筛选）：被依赖数越多，气泡越大 -->
            <div class="dep-table-title">
              关键依赖节点
              <span class="dep-table-filter-hint">（{{ currentListLabel }} · 气泡越大被依赖越多）</span>
            </div>
            <div v-if="!topNodesLoading && !keyDependencies.length" class="dep-hint">暂无数据</div>
            <div v-else-if="keyDependencies.length" class="key-deps-chart" ref="keyDepsChart"></div>
          </div>
        </div>

        <!-- 风险域名案例看板 -->
        <div class="section-card">
          <div class="card-title">风险域名案例看板</div>
          <div class="risk-case-filter-bar">
            <el-input
              v-model.trim="riskCaseFilters.keyword"
              size="small"
              class="risk-case-search"
              clearable
              placeholder="搜索域名 / 风险 / 证据"
            >
              <i slot="prefix" class="el-icon-search"></i>
            </el-input>
            <el-select v-model="riskCaseFilters.severity" size="small" clearable placeholder="优先级">
              <el-option label="P0" value="P0"></el-option>
              <el-option label="P1" value="P1"></el-option>
              <el-option label="P2" value="P2"></el-option>
            </el-select>
            <el-select v-model="riskCaseFilters.group" size="small" clearable placeholder="风险分组">
              <el-option
                v-for="group in riskCaseGroupOptions"
                :key="group"
                :label="group"
                :value="group"
              ></el-option>
            </el-select>
            <el-select v-model="riskCaseFilters.confirm" size="small" clearable placeholder="确认方式">
              <el-option label="主动确认" value="active"></el-option>
              <el-option label="被动确认" value="passive"></el-option>
              <el-option label="人工确认" value="manual"></el-option>
            </el-select>
            <el-button size="small" icon="el-icon-refresh-left" @click="resetRiskCaseFilters">重置</el-button>
            <span class="risk-case-count">
              共 {{ riskCasesTotal.toLocaleString() }} 条
            </span>
          </div>
        <el-table
          ref="riskCasesTable"
          v-loading="riskCasesLoading"
          :data="riskCases"
          class="risk-cases-table"
          @row-click="handleRiskCaseRowExpand"
        >
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="risk-case-detail">
                <div class="detail-block">
                  <div class="detail-title">证据摘要</div>
                  <div v-if="scope.row.evidence.length">
                    <div v-for="(line, idx) in scope.row.evidence" :key="idx" class="detail-line">{{ line }}</div>
                  </div>
                  <div v-else class="detail-line muted">暂无证据摘要</div>
                </div>
                <div class="detail-block">
                  <div class="detail-title">建议动作</div>
                  <div class="detail-line">{{ scope.row.recommendation }}</div>
                  <div class="detail-title sub">优先级依据</div>
                  <div class="detail-line">{{ scope.row.priorityBasis }}</div>
                </div>
                <div class="detail-block compact">
                  <div class="detail-title">结果来源</div>
                  <div class="detail-line">任务：{{ scope.row.taskType }}</div>
                  <div class="detail-line">Run ID：{{ scope.row.runId }}</div>
                  <div v-if="scope.row.sourceRunId && scope.row.sourceRunId !== scope.row.runId" class="detail-line">
                    源轮次：{{ scope.row.sourceRunId }}
                  </div>
                  <div class="detail-line">列表：{{ scope.row.source }}</div>
                  <div class="detail-line">排名：{{ scope.row.rankDetail }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="severity" label="优先级" width="82">
            <template slot-scope="scope">
              <span class="severity-badge" :class="severityClass(scope.row.severity)">{{ scope.row.severity }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="domain" label="域名" min-width="190">
            <template slot-scope="scope">
              <span
                class="domain-link"
                @click.stop="handleRiskCaseClick(scope.row)"
                title="点击跳转到风险查询"
              >{{ scope.row.domain }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="source" label="所属列表" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="rankText" label="排名/归属" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="runId" label="Run ID" min-width="145" show-overflow-tooltip></el-table-column>
          <el-table-column prop="group" label="风险分组" width="130"></el-table-column>
          <el-table-column label="风险项" min-width="180">
            <template slot-scope="scope">
              <span v-for="(risk, idx) in scope.row.risks" :key="idx" class="risk-tag">{{ risk }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="evidenceText" label="证据摘要" min-width="240" show-overflow-tooltip></el-table-column>
          <el-table-column prop="confirmLevel" label="确认层级" width="105"></el-table-column>
          <el-table-column label="检查状态" width="150">
            <template slot-scope="scope">
              <span class="status-badge" :class="scope.row.status.passive ? 'active' : 'inactive'">被动</span>
              <span class="status-badge" :class="scope.row.status.active ? 'active' : 'inactive'">主动</span>
              <span class="status-badge" :class="scope.row.status.manual ? 'active' : 'inactive'">人工</span>
            </template>
          </el-table-column>
        </el-table>
          <div class="risk-case-pagination">
            <el-pagination
              background
              :current-page="riskCasesPage"
              :page-size="riskCasesSize"
              :page-sizes="[20, 50, 100]"
              :total="riskCasesTotal"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleRiskCaseSizeChange"
              @current-change="handleRiskCasePageChange"
            ></el-pagination>
          </div>
        </div>
      </div>

      <!-- 子页面2：风险查询 -->
      <div v-if="activeTab === 'riskquery'" class="tab-panel">
        <div class="query-layout">
          <!-- 右侧内容 -->
          <div class="query-main">
            <!-- 搜索模式切换 -->
            <div style="margin-bottom:12px">
              <el-radio-group v-model="searchMode" size="small">
                <el-radio-button label="domain">按域名</el-radio-button>
                <el-radio-button label="company">按机构</el-radio-button>
              </el-radio-group>
            </div>

            <!-- 按域名搜索栏 -->
            <div v-if="searchMode === 'domain'" class="search-bar">
              <el-input
                v-model="querySearch"
                placeholder="域名风险查询：example.com 支持检索式（根据各个维度的信息搜索）"
                class="search-input"
                @keyup.enter.native="doQuery"
              >
                <i slot="suffix" class="el-icon-search"></i>
              </el-input>
              <el-select v-model="domainQueryType" placeholder="风险类别" clearable style="width:120px">
                <el-option label="全部风险" value="" />
                <el-option label="悬空NS记录" value="悬空记录" />
                <el-option label="孤儿DNS服务器" value="孤儿DNS服务器" />
                <el-option label="僵尸NS记录" value="僵尸NS记录" />
                <el-option label="跛脚委派" value="跛脚委派" />
                <el-option label="循环授权" value="循环授权" />
                <el-option label="NS记录不一致" value="NS记录不一致" />
                <el-option label="父侧无NS" value="父侧无NS" />
                <el-option label="子侧无NS" value="子侧无NS" />
                <el-option label="陈旧胶水记录" value="陈旧胶水记录" />
                <el-option label="父侧缺Glue" value="父侧缺Glue" />
                <el-option label="子侧缺Glue" value="子侧缺Glue" />
              </el-select>
              <el-button type="primary" @click="doQuery">查询</el-button>
              <el-button @click="doQueryRealtime" title="跳过MongoDB，直接发起实时探测">实时探测</el-button>
              <el-button @click="exportReport"><i class="el-icon-download"></i> 导出报告</el-button>
            </div>

            <!-- 按机构搜索栏 -->
            <div v-if="searchMode === 'company'" class="search-bar">
              <el-input
                v-model="companySearch"
                placeholder="输入机构名称（支持模糊查询）"
                style="flex:1;min-width:200px"
                clearable
                @keyup.enter.native="doCompanyQuery(1)"
              >
                <i slot="prefix" class="el-icon-search"></i>
              </el-input>
              <el-date-picker
                v-model="companyQueryDate"
                type="date"
                placeholder="选择日期（默认最新批次）"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                size="small"
                style="width:200px"
                clearable
                :picker-options="tracePickerOptions"
              ></el-date-picker>
              <el-button type="primary" @click="doCompanyQuery(1)">查询</el-button>
              <el-button @click="exportReport"><i class="el-icon-download"></i> 导出报告</el-button>
            </div>

            <!-- 数据表格 -->
            <el-table
              :data="queryTableData"
              class="query-table"
              row-key="id"
              :expand-row-keys="expandedRowKeys"
              @expand-change="handleQueryExpandChange"
            >
              <el-table-column type="expand">
                <template slot-scope="scope">
                  <div class="query-row-detail">
                    <!-- 风险案例详情（仅有风险时展示） -->
                    <div v-if="scope.row.state === 'has_risk'" class="risk-case-detail">
                      <div class="detail-block">
                        <div class="detail-title">证据摘要</div>
                        <div v-if="(scope.row.evidence || []).length">
                          <div v-for="(line, i) in scope.row.evidence" :key="i" class="detail-line">{{ line }}</div>
                        </div>
                        <div v-else class="detail-line muted">暂无证据摘要</div>
                      </div>
                      <div class="detail-block">
                        <div class="detail-title">建议动作</div>
                        <div class="detail-line">{{ scope.row.recommendation || '核对原始探测证据并按风险类型处置。' }}</div>
                        <div class="detail-title sub">优先级依据</div>
                        <div class="detail-line">{{ scope.row.priorityBasis || '按风险类型的影响面、可利用性和恢复紧急度综合排序。' }}</div>
                      </div>
                      <div class="detail-block compact">
                        <div class="detail-title">结果来源</div>
                        <div class="detail-line">任务：{{ scope.row.taskType || '-' }}</div>
                        <div class="detail-line">Run ID：{{ scope.row.runId || '-' }}</div>
                        <div v-if="scope.row.sourceRunId && scope.row.sourceRunId !== scope.row.runId" class="detail-line">
                          源轮次：{{ scope.row.sourceRunId }}
                        </div>
                        <div v-if="scope.row.confirmLevel" class="detail-line">确认层级：{{ scope.row.confirmLevel }}</div>
                      </div>
                    </div>
                    <div v-else-if="scope.row.state === 'no_risk'" class="state-banner state-no-risk">该域名在当前批次探测中未发现授权风险</div>
                    <div v-else class="state-banner state-not-probed">该域名在当前批次未被探测</div>

                    <!-- 授权依赖图 -->
                    <div class="dep-graph-panel-inline">
                      <div class="dep-graph-header">
                        <span class="card-title">授权依赖图</span>
                        <span class="dep-graph-time" v-if="scope.row.depGraphTime">构建时间：{{ scope.row.depGraphTime }}</span>
                      </div>
                      <div v-if="scope.row.depGraphLoading" class="dep-hint">加载中...</div>
                      <div v-else-if="scope.row.depGraphEmpty" class="dep-hint">暂无依赖图数据</div>
                      <div v-else class="dep-graph-container" :ref="`queryDepChart_${scope.row.id}`"></div>
                      <div class="dep-graph-legend">
                        <div class="legend-item"><span class="legend-box risk-box"></span>风险节点</div>
                        <div class="legend-item"><span class="legend-box normal-box"></span>正常节点</div>
                        <div class="legend-item"><span class="legend-line dashed-line risk-line"></span>风险NS依赖</div>
                        <div class="legend-item"><span class="legend-line dashed-line"></span>潜在风险路径</div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="id" label="ID" width="60"></el-table-column>
              <el-table-column prop="domain" label="域名" min-width="180">
                <template slot-scope="scope">
                  <span class="domain-link">{{ scope.row.domain }}</span>
                </template>
              </el-table-column>
              <el-table-column label="归属的组织机构" min-width="180">
                <template slot-scope="scope">
                  <template v-if="scope.row.companiesLoading">
                    <span class="muted">查询中...</span>
                  </template>
                  <template v-else-if="(scope.row.companies || []).length">
                    <span v-for="(c, i) in scope.row.companies" :key="i" class="company-tag">{{ c }}</span>
                  </template>
                  <template v-else>
                    <span class="muted">-</span>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="风险状态" width="270">
                <template slot-scope="scope">
                  <span class="state-badge" :class="'state-' + scope.row.state">{{ stateLabel(scope.row.state) }}</span>
                  <span
                    v-if="scope.row.state === 'has_risk' && scope.row.severity"
                    class="severity-badge"
                    :class="severityClass(scope.row.severity)"
                  >{{ scope.row.severity }}</span>
                  <span v-for="(r, i) in (scope.row.riskType || [])" :key="i" class="risk-tag">{{ r }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="discoveryTime" label="发现时间（被动）" width="130"></el-table-column>
              <el-table-column label="验证时间（主动/人工）" width="160">
                <template slot-scope="scope">
                  <div v-if="scope.row.verifyTimeActive">{{ scope.row.verifyTimeActive }}（主动）</div>
                  <div v-if="scope.row.verifyTimeManual">{{ scope.row.verifyTimeManual }}（人工）</div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="70">
                <template slot-scope="scope">
                  <el-button type="text" @click.stop="toggleDepGraph(scope.row.id)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>

            <!-- 机构查询分页 -->
            <div v-if="searchMode === 'company' && companyQueryTotal > 0" style="margin-top:12px;text-align:right">
              <el-pagination
                :current-page="companyQueryPage"
                :page-size="companyQuerySize"
                :total="companyQueryTotal"
                layout="total, prev, pager, next"
                @current-change="doCompanyQuery"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- 子页面3：状态回溯 -->
      <div v-if="activeTab === 'traceback'" class="tab-panel">
        <div class="section-card">
          <!-- 搜索栏 -->
          <div class="search-bar">
            <el-input
              v-model="traceSearch"
              placeholder="授权依赖状态查询：example.com"
              class="search-input"
              @keyup.enter.native="doTrace"
            >
              <i slot="suffix" class="el-icon-search"></i>
            </el-input>
            <el-button type="primary" @click="doTrace">查询</el-button>
            <el-button @click="exportReport"><i class="el-icon-download"></i> 导出报告</el-button>
          </div>

          <!-- 时间选择器 -->
          <div class="time-picker-bar">
            <i class="el-icon-date time-icon"></i>
            <div>
              <div class="time-picker-label">选择回溯时间点</div>
              <el-date-picker
                v-model="traceDate"
                type="date"
                placeholder="选择日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                size="small"
                :picker-options="tracePickerOptions"
              ></el-date-picker>
            </div>
          </div>

          <!-- 依赖状态图 -->
          <div class="trace-graph-section">
            <div class="trace-graph-header">
              <span class="card-title">{{ traceDate || '请选择时间' }}时授权依赖状态</span>
              <div class="trace-graph-controls">
                <el-select v-model="traceDepLevel" size="small" style="width:120px">
                  <el-option label="关键依赖" value="critical"></el-option>
                  <el-option label="基本依赖" value="essential"></el-option>
                  <el-option label="显式依赖" value="explicit"></el-option>
                  <el-option label="一般依赖" value="general"></el-option>
                </el-select>
                <el-button type="primary" size="small" @click="doTrace">查询</el-button>
              </div>
            </div>

            <!-- 图例 -->
            <div class="trace-legend-bar">
              <div class="legend-item"><span class="legend-line solid-line"></span>NS授权依赖</div>
              <div class="legend-item"><span class="legend-line dashed-line green-line"></span>父子域依赖</div>
            </div>

            <div class="trace-graph-container" ref="traceChart"></div>
          </div>
        </div>
      </div>
    </div><!-- /main-content -->

    <div v-if="isLoading" class="loading-overlay">
      <div class="loading-content">
        <div class="loading-dots">
          <span></span><span></span><span></span>
        </div>
        <div class="loading-text">{{ loadingText }}</div>
      </div>
    </div>

    <!-- 底部导航 -->
    <navigation></navigation>

    <footer class="beian-footer">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">鲁ICP备2026032922号-1</a>
      <span>|</span>
      <a class="beian-police-link" href="https://beian.mps.gov.cn/#/query/webSearch?code=37140202001764" rel="noreferrer" target="_blank">
        <img class="beian-police-logo" src="/beian-police.png" alt="公安备案图标" />
        <span>鲁公网安备37140202001764号</span>
      </a>
    </footer>
  </div>
</template>

<script>
import axios from "axios";
import Navigation from "@/components/navigation.vue";
import DpHeader from "@/components/dp-header.vue";
import {
  getEntityInfo,
  getDomainAuthRiskList,
  getDomainCompanyBatch
} from "@/service/dashboard";

const AUTH_DEP_API     = "/authdep-api";
const AUTH_DEP_HEADERS = { "Content-Type": "application/json" };
const AUTHDEP_MONGO_API = "/authdep-mongo";

/**
 * 前端 filter value → MongoDB 列表名 映射
 * mongoName    须与数据库 graphs/memberships 里 lists 字段的实际值一致
 * label        对外展示短名，须与后端 authdep-mongo-api.js 的 LIST_FRIENDLY_NAMES 保持一致。
 *              风险案例表"所属列表"列与筛选项用这套短名，和日志/原始数据对得上。
 * displayLabel 界面友好名，用于"各列表授权依赖概览"表首列——短名（tranco_top1m）
 *              对使用者没有可读性，这里用中文名。
 */
const DEFINED_LISTS = [
  { value: "tranco",     mongoName: "trancotop1mdomains", label: "tranco_top1m",  displayLabel: "Tranco" },
  { value: "secrank",    mongoName: "secrank_domains",    label: "secrank_top1m", displayLabel: "Secrank" },
  { value: "cloudflare", mongoName: "cloudflare_domains", label: "cf_top1m",      displayLabel: "Cloudflare" },
  { value: "edugov",     mongoName: "edugov",             label: "edugov",        displayLabel: "全球govedu" },
  { value: "domestic",   mongoName: "company_domains",    label: "institutional", displayLabel: "国内重要机构" }
];
// MongoDB 原始库名 → 展示短名，供风险案例表"所属列表"列把原始 lists 映射成友好短名
const LIST_SHORT_NAMES = DEFINED_LISTS.reduce((m, d) => {
  m[d.mongoName] = d.label;
  return m;
}, {});

const RISK_LABELS = {
  loop: "循环授权",
  orphan: "孤儿DNS服务器",
  inconsistency: "NS记录不一致",
  glue_inconsistency: "陈旧胶水记录",
  parent_no_ns: "父侧无NS",
  child_no_ns: "子侧无NS",
  parent_no_glue: "父侧缺Glue",
  child_no_glue: "子侧缺Glue",
  dangling_ns: "悬空NS记录",
  lame: "跛脚委派",
  zombie: "僵尸NS记录"
};

// 各风险 code 的优先级，与后端 authdep-mongo-api.js 的 RISK_META.severity 对齐。
// 实时探测等前端场景据此取真实分级，不再统一硬编码 P2。
// 注：后端当前只探测 6 类 check —— relation(产出 inconsistency/glue_inconsistency/
// parent_no_ns/child_no_ns/parent_no_glue/child_no_glue)、dangling、orphan、loop、
// lame。下方标注"未启用探测"的项为历史预留定义，当前数据库无数据、
// UI 不会展示；保留定义以便将来恢复探测时直接复用。
const RISK_SEVERITY = {
  dangling_ns: "P0",
  dangling: "P0",
  orphan: "P0",
  zombie: "P0",
  lame: "P1",
  loop: "P1",
  inconsistency: "P1",
  parent_no_ns: "P1",
  child_no_ns: "P1",
  glue_inconsistency: "P2",
  parent_no_glue: "P2",
  child_no_glue: "P2",
  // ↓↓↓ 以下为当前未启用探测的历史预留项（无数据，UI 不展示）↓↓↓
  ip_count_low: "P2",
  same_subnet: "P2",
  slow_response: "P2",
  no_ipv6: "P3",
  no_any: "P3",
  no_edns: "P3",
  no_www: "P3",
  abnormal_www_ttl: "P3"
};
// 取一组风险中的最高优先级（P0 最高）
const SEVERITY_RANK = {
  P0: 0,
  P1: 1,
  P2: 2,
  P3: 3
};

const RISK_GROUP_ORDER = [
  "父子域NS不一致",
  "接管风险",
  "拒绝服务",
  "其他授权健康风险"
];

export default {
  name: "AuthDep",
  components: { Navigation, DpHeader },
  data() {
    return {
      activeTab: "dashboard",
      tabs: [
        { label: "风险态势", value: "dashboard" },
        { label: "风险查询", value: "riskquery" },
        { label: "状态回溯", value: "traceback" }
      ],
      lastScanTime: "-",
      dashFilter: { source: "all", dimension: "all" },
      scanStats: { total: 0, nsDependency: 0, done: 0, running: 0, pending: 0, failed: 0 },
      riskDataNsInconsistency: [
        { type: RISK_LABELS.inconsistency, org: null, domain: 0, color: "#22c55e", key: "inconsistency" }
      ],
      riskDataTakeover: [
        { type: RISK_LABELS.dangling_ns, org: null, domain: 0, color: "#ef4444", key: "dangling_ns" },
        { type: RISK_LABELS.orphan, org: null, domain: 0, color: "#fb923c", key: "orphan" },
        { type: RISK_LABELS.zombie, org: null, domain: 0, color: "#06b6d4", key: "zombie" }
      ],
      riskDataDos: [
        { type: RISK_LABELS.lame, org: null, domain: 0, color: "#f97316", key: "lame" },
        { type: RISK_LABELS.loop, org: null, domain: 0, color: "#eab308", key: "loop" }
      ],
      riskDataOther: [
        {
          type: "其他授权健康风险",
          org: null,
          domain: 0,
          color: "#60a5fa",
          keys: [
            "glue_inconsistency",
            "parent_no_ns",
            "child_no_ns",
            "parent_no_glue",
            "child_no_glue"
          ],
          detail: "包含：陈旧胶水记录、父侧无NS、子侧无NS、父侧缺Glue、子侧缺Glue"
        }
      ],
      keyDependencies: [],
      // MongoDB 授权依赖概览
      overviewStats:   null,     // { run_id, date, lists: [{name,count,avgDepth,avgMaxDepth}] }
      listStatsTable:  [],       // 格式化后供表格展示（含 friendlyName）
      coreMetricsLoading: false, // 核心指标看板 loading
      riskStatsLoading: false,   // 授权依赖风险看板 loading
      topNodesLoading: false,
      riskCases: [],
      riskCasesLoading: false,
      riskCasesPage: 1,
      riskCasesSize: 50,
      riskCasesTotal: 0,
      riskCaseFilterTimer: null,
      riskCaseFilters: {
        keyword: "",
        severity: "",
        group: "",
        confirm: ""
      },
      unknownStats: {
        needs_reverify: 0,
        needs_ns_backfill: 0,
        pdns_error: 0,
        requires_active_probe: 0,
        ns_missing: 0,
        not_delegated_subdomain: 0
      },
      querySearch: "",
      domainQueryType: "",
      searchMode: "domain",
      companySearch: "",
      companyQueryDate: "",
      companyQueryTotal: 0,
      companyQueryPage: 1,
      companyQuerySize: 20,
      queryTableData: [],
      expandedRowKeys: [],
      queryDepChartInstances: {},
      selectedQueryRow: null,
      depGraphTime: "",
      queryLoading: false,
      isLoading: false,
      loadingText: "",
      loadingTimer: null,
      loadingSteps: [
        "Querying authoritative NS records...",
        "Checking parent zone delegation...",
        "Verifying child zone response...",
        "Detecting dangling records...",
        "Analyzing lame delegations...",
        "Scanning for circular dependencies...",
        "Evaluating NS consistency...",
        "Almost there..."
      ],
      loadingStepIndex: 0,
      traceSearch: "",
      traceDate: "",
      traceDepLevel: "general",
      traceLoading: false,
      availableDates: [],
      pieChartInstance: null,
      queryDepChartInstance: null,
      traceChartInstance: null,
      keyDepsChartInstance: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.loadDashboard();
    });
  },
  computed: {
    currentListLabel() {
      const source = this.dashFilter.source;

      if (source === "all") {
        return "全部";
      }
      const def = DEFINED_LISTS.find(d => d.value === source);

      return def ? def.label : source;
    },
    riskGroups() {
      return [
        { key: "ns", label: "父子域NS不一致", items: this.riskDataNsInconsistency },
        { key: "takeover", label: "接管风险", items: this.riskDataTakeover },
        { key: "dos", label: "拒绝服务", items: this.riskDataDos },
        { key: "other", label: "其他授权健康风险", items: this.riskDataOther }
      ];
    },
    groupIconMap() {
      return {
        ns: "el-icon-warning-outline",
        takeover: "el-icon-warning",
        dos: "el-icon-warning",
        other: "el-icon-info"
      };
    },
    riskCaseGroupOptions() {
      const groups = [...new Set([
        ...RISK_GROUP_ORDER,
        ...this.riskCases.map(item => item.group).filter(Boolean)
      ])];

      return groups.sort((a, b) => {
        const ia = RISK_GROUP_ORDER.indexOf(a);
        const ib = RISK_GROUP_ORDER.indexOf(b);

        if (ia !== -1 || ib !== -1) {
          return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
        }
        return a.localeCompare(b, "zh-CN");
      });
    },
    coreMetrics() {
      const takeoverTotal = this.riskDataTakeover.reduce((s, i) => s + (i.domain || 0), 0);
      const dosTotal = this.riskDataDos.reduce((s, i) => s + (i.domain || 0), 0);
      const lists = this.overviewStats ? (this.overviewStats.lists || []) : [];
      const depths = lists.map(l => l.avgDepth).filter(v => v != null);
      const avgDepth = depths.length ? (depths.reduce((a, b) => a + b, 0) / depths.length).toFixed(1) : "-";

      return {
        totalDomains: this.overviewStats ? (this.overviewStats.totalDomains || 0) : 0,
        takeoverTotal,
        dosTotal,
        avgDepth
      };
    },
    scanTaskRows() {
      return [
        {
          item: "扫描时间",
          value: this.overviewStats ? (this.overviewStats.scanTimeRange || this.overviewStats.scanTime || "-") : "-"
        },
        {
          item: "轮次编号",
          value: this.overviewStats ? (this.overviewStats.run_id || "-") : "-"
        },
        {
          item: "扫描域名总数",
          value: this.overviewStats && this.overviewStats.totalDomains
            ? this.overviewStats.totalDomains.toLocaleString()
            : "-"
        },
        {
          item: "覆盖列表数",
          value: this.overviewStats && this.overviewStats.lists ? this.overviewStats.lists.length : "-"
        },
        {
          item: "待主动复核",
          value: this.unknownStats.needs_reverify.toLocaleString()
        },
        {
          item: "待NS补全",
          value: this.unknownStats.needs_ns_backfill.toLocaleString()
        },
        {
          item: "PDNS失败/无数据",
          value: (this.unknownStats.pdns_error + this.unknownStats.ns_missing).toLocaleString()
        },
        {
          item: "普通子域无独立授权",
          value: (this.unknownStats.not_delegated_subdomain || 0).toLocaleString()
        }
      ];
    },
    tracePickerOptions() {
      const dates = new Set(this.availableDates);

      return {
        disabledDate(date) {
          const d = `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,"0")}-${String(date.getDate()).padStart(2,"0")}`;

          return !dates.has(d);
        },
        cellClassName(date) {
          const d = `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,"0")}-${String(date.getDate()).padStart(2,"0")}`;

          return dates.has(d) ? "available-date" : "";
        }
      };
    }
  },

  watch: {
    keyDependencies(val) {
      if (val && val.length) {
        this.$nextTick(() => this.renderKeyDepsChart());
      } else if (this.keyDepsChartInstance) {
        this.keyDepsChartInstance.dispose();
        this.keyDepsChartInstance = null;
      }
    },
    activeTab(val) {
      this.$nextTick(() => {
        if (val === "dashboard") {
          this.loadDashboard();
        }
        if (val === "riskquery") {
          if (!this.availableDates.length) {
            this.loadAvailableDates();
          }
        }
        if (val === "traceback") {
          if (this.traceChartInstance) {
            this.traceChartInstance.resize();
          }
          this.loadAvailableDates();
        }
      });
    },
    selectedQueryRow(val) {
      if (val) {
        this.$nextTick(() => this.renderQueryDepChart());
      }
    },
    searchMode() {
      this.queryTableData = [];
      this.selectedQueryRow = null;
    },
    /** 数据源或统计维度切换时重新加载整个 dashboard */
    "dashFilter.source"() {
      this.loadDashboard();
    },
    "dashFilter.dimension"() {
      this.loadDashboard();
    },
    /** 状态回溯：日期或依赖层级切换时自动重新拉取依赖图 */
    traceDate(val) {
      if (this.activeTab === "traceback" && val && this.traceSearch.trim()) {
        this.doTrace();
      }
    },
    traceDepLevel() {
      if (this.activeTab === "traceback" && this.traceDate && this.traceSearch.trim()) {
        this.doTrace();
      }
    },
    riskCaseFilters: {
      deep: true,
      handler() {
        if (this.activeTab !== "dashboard") {
          return;
        }
        clearTimeout(this.riskCaseFilterTimer);
        this.riskCaseFilterTimer = setTimeout(() => {
          this.loadRiskCases(1);
        }, 300);
      }
    }
  },
  methods: {
    /**
     * 组装 dashboard 相关接口的公共查询参数。
     * @param {object} extra 额外参数
     * @param {object} [opts]
     * @param {boolean} [opts.allLists=false] 为 true 时不带 list —— 供"各列表授权依赖概览"
     *   这类需要横向对比所有列表的表格使用。带上 list 会让后端把聚合锁死到单个列表，
     *   返回的 lists 只剩一项，表格里其余 4 行全部落成 0 / '-'，失去对比意义。
     */
    getDashboardParams(extra = {}, opts = {}) {
      const params = { ...extra };

      if (!opts.allLists && this.dashFilter.source && this.dashFilter.source !== "all") {
        const def = DEFINED_LISTS.find(d => d.value === this.dashFilter.source);

        params.list = def ? def.mongoName : this.dashFilter.source;
      }
      if (this.dashFilter.dimension && this.dashFilter.dimension !== "all") {
        params.dimension = this.dashFilter.dimension;
      }
      return params;
    },
    riskLabel(type) {
      return RISK_LABELS[type] || type;
    },
    severityOf(codes) {
      // 取一组 risk code 中的最高优先级，缺省按 P3 兜底
      let best = null;

      for (const c of (codes || [])) {
        const sev = RISK_SEVERITY[c] || "P3";

        if (best === null || SEVERITY_RANK[sev] < SEVERITY_RANK[best]) {
          best = sev;
        }
      }
      return best || "P3";
    },
    confirmLabel(confirmLevel) {
      const labels = {
        passive_confirmed: "被动确认",
        active_confirmed: "主动确认",
        not_confirmed: "未确认"
      };

      return labels[confirmLevel] || confirmLevel || "-";
    },
    riskCount(item, counts) {
      if (item.keys) {
        return item.keys.reduce((sum, key) => sum + (counts[key] ? counts[key].count : 0), 0);
      }
      return item.key && counts[item.key] ? counts[item.key].count : 0;
    },
    applyRiskCounts(items, counts) {
      return items.map(item => ({
        ...item,
        domain: this.riskCount(item, counts)
      }));
    },
    severityClass(severity) {
      return `severity-${String(severity || "P3").toLowerCase()}`;
    },
    resetRiskCaseFilters() {
      this.riskCaseFilters = {
        keyword: "",
        severity: "",
        group: "",
        confirm: ""
      };
    },
    riskCaseApiParams(page = this.riskCasesPage) {
      const params = this.getDashboardParams({
        page,
        size: this.riskCasesSize
      });

      if (this.riskCaseFilters.keyword) {
        params.q = this.riskCaseFilters.keyword;
      }
      if (this.riskCaseFilters.severity) {
        params.severity = this.riskCaseFilters.severity;
      }
      if (this.riskCaseFilters.group) {
        params.group = this.riskCaseFilters.group;
      }
      if (this.riskCaseFilters.confirm) {
        params.confirm = this.riskCaseFilters.confirm;
      }
      return params;
    },
    /**
     * 加载风险案例列表。
     * @param {number} page 页码
     * @param {number} [seq] 调用方的请求序号（来自 loadDashboard）。
     *   传入时若已被更新的调用取代，则丢弃本次响应，避免旧数据覆盖新数据。
     *   翻页等独立触发场景不传，行为与之前一致。
     */
    async loadRiskCases(page = this.riskCasesPage, seq = null) {
      const isStale = () => seq !== null && seq !== this._dashSeq;

      this.riskCasesLoading = true;
      try {
        const casesRes = await axios.get(`${AUTHDEP_MONGO_API}/risk-cases`, {
          params: this.riskCaseApiParams(page),
          timeout: 60000
        });

        if (isStale()) {
          return;
        }
        const cases = (casesRes.data.cases || []).map((doc, idx) => (
          this.formatRiskCase(doc, (page - 1) * this.riskCasesSize + idx)
        ));

        this.riskCases = cases;
        this.riskCasesTotal = casesRes.data.total || this.riskCases.length;
        this.riskCasesPage = page;
      } catch (e) {
        if (isStale()) {
          return;
        }
        console.error("[dashboard] 风险案例加载失败", e);
        this.riskCases = [];
        this.riskCasesTotal = 0;
      } finally {
        if (!isStale()) {
          this.riskCasesLoading = false;
        }
      }
    },
    handleRiskCasePageChange(page) {
      this.loadRiskCases(page);
    },
    handleRiskCaseSizeChange(size) {
      this.riskCasesSize = size;
      this.loadRiskCases(1);
    },
    formatRiskCase(doc, index) {
      const cs = doc.check_status || {};
      const evidence = Array.isArray(doc.evidence_summary) ? doc.evidence_summary : [];
      const risks = doc.risk_labels && doc.risk_labels.length
        ? doc.risk_labels
        : (doc.risk_types || []).map(this.riskLabel);
      const listRanks = Array.isArray(doc.list_ranks) ? doc.list_ranks : [];
      const listTags  = Array.isArray(doc.list_tags)  ? doc.list_tags  : [];
      const tagText = listTags.map(item => item.note).filter(Boolean).join("；");
      const selectedList = DEFINED_LISTS.find(d => d.value === this.dashFilter.source);
      const selectedMongoName = selectedList && selectedList.mongoName;
      const selectedTag = selectedMongoName
        ? listTags.find(item => item.list === selectedMongoName)
        : null;
      const selectedRank = selectedMongoName
        ? listRanks.find(item => item.list === selectedMongoName)
        : null;
      const sourceText = (doc.lists || []).map(l => LIST_SHORT_NAMES[l] || l).join(", ") || doc.source || "-";
      const isSelectedTagList = selectedMongoName === "edugov" || selectedMongoName === "company_domains";
      const isSourceTagList = /(^|,\s*)(edugov|institutional)(\s*,|$)/.test(sourceText);
      const rankText = isSelectedTagList || isSourceTagList
        ? ((selectedTag && selectedTag.note) || tagText || "-")
        : (selectedRank
          ? `#${Number(selectedRank.rank).toLocaleString()}`
          : (doc.best_list_rank ? `#${doc.best_list_rank.toLocaleString()}` : (tagText || "-")));
      const rankDetailParts = [
        ...listRanks.map(item => `${item.label || item.list} #${Number(item.rank).toLocaleString()}`),
        ...listTags.map(item => `${item.label}：${item.note}`)
      ];
      const rankDetail = rankDetailParts.length ? rankDetailParts.join("；") : "-";

      return {
        id: index + 1,
        domain: doc.domain,
        source: sourceText,
        rankText,
        rankDetail,
        group: doc.risk_group || "其他",
        severity: doc.severity || "P3",
        risks,
        evidence,
        evidenceText: evidence.length ? evidence.join("；") : "-",
        recommendation: doc.recommendation || "核对原始探测证据并按风险类型处置。",
        priorityBasis: doc.priority_basis || "按风险类型的影响面、可利用性和恢复紧急度综合排序。",
        taskType: doc.task_type || "-",
        runId: doc.run_id || "-",
        sourceRunId: doc.source_run_id || "",
        confirmLevel: this.confirmLabel(cs.confirm_level || doc.confirm_level),
        status: {
          passive: (cs.confirm_level || doc.confirm_level) === "passive_confirmed" || cs.passive_detected === true,
          active:  (cs.confirm_level || doc.confirm_level) === "active_confirmed" || cs.active_verified === true,
          manual:  cs.manual_confirmed ?? false
        }
      };
    },
    initPieChart() {
      if (!this.$refs.pieChart) {
        return;
      }
      const echarts = require("echarts");

      if (this.pieChartInstance) {
        this.pieChartInstance.dispose();
      }
      this.pieChartInstance = echarts.init(this.$refs.pieChart);
      this.pieChartInstance.setOption({
        tooltip: { trigger: "item", formatter: "{b}: {c} ({d}%)" },
        legend: { bottom: 0, textStyle: { color: "#C1D5FF" } },
        series: [{
          type: "pie",
          radius: ["45%", "70%"],
          data: [
            { name: "已完成", value: this.scanStats.done, itemStyle: { color: "#3b82f6" } },
            { name: "进行中", value: this.scanStats.running, itemStyle: { color: "#ef4444" } },
            { name: "待处理", value: this.scanStats.pending, itemStyle: { color: "#f59e0b" } },
            { name: "失败", value: this.scanStats.failed, itemStyle: { color: "#8b5cf6" } }
          ],
          label: { color: "#C1D5FF", fontSize: 11 }
        }],
        backgroundColor: "transparent"
      });
    },
    async loadDashboard() {
      // 请求序号守卫：切换数据源/维度时会连续触发多次 loadDashboard，
      // 而 daily-stats / overview-stats / top-nodes 的响应耗时差异很大
      // （冷聚合可达分钟级）。没有守卫时，先发出的旧请求会后于新请求返回，
      // 把已经渲染好的新数据覆盖成旧源的数据 —— 表现就是"每切一次数据源，
      // 整张概览表都被重刷一遍"。每次调用领取一个序号，只有最新那次有权写状态。
      const seq = (this._dashSeq = (this._dashSeq || 0) + 1);
      const isStale = () => seq !== this._dashSeq;

      // ── Part 1：MongoDB 风险统计 ──────────────────────────────────
      this.riskStatsLoading = true;
      try {
        const statsRes = await axios.get(`${AUTHDEP_MONGO_API}/daily-stats`, {
          params: this.getDashboardParams(),
          timeout: 60000
        });

        if (isStale()) {
          return;
        }

        // 后端在缓存未命中时会返回 202 + { pending: true, message }
        // 此时不应当用空数据覆盖现有展示——保留旧值并给一次温和提示
        if (statsRes.status === 202 || (statsRes.data && statsRes.data.pending)) {
          const msg = (statsRes.data && statsRes.data.message)
            || "风险统计正在后台计算，请稍后刷新";

          if (!this._dailyStatsPendingNoticeShown) {
            this.$message.info(msg);
            this._dailyStatsPendingNoticeShown = true;
          }
        } else {
          // 收到真实数据，重置提示标志，下次再 pending 可以再提示一次
          this._dailyStatsPendingNoticeShown = false;
          const s = statsRes.data;
          const run_id = s.run_id || "";

          if (run_id.length >= 8) {
            this.lastScanTime = `${run_id.slice(0,4)}年${run_id.slice(4,6)}月${run_id.slice(6,8)}日`;
          }
          this.scanStats.total = s.total_scanned || 0;
          this.scanStats.nsDependency = s.ns_dependency_count || 0;
          const rc = s.confirmed_risk_counts || s.risk_counts || {};

          this.unknownStats = {
            ...this.unknownStats,
            ...(s.status_counts || {})
          };
          this.riskDataNsInconsistency = this.applyRiskCounts(this.riskDataNsInconsistency, rc);
          this.riskDataTakeover = this.applyRiskCounts(this.riskDataTakeover, rc);
          this.riskDataDos = this.applyRiskCounts(this.riskDataDos, rc);
          this.riskDataOther = this.applyRiskCounts(this.riskDataOther, rc);
        }
        await this.loadRiskCases(1, seq);
      } catch (e) {
        if (isStale()) {
          return;
        }
        console.error("[dashboard] MongoDB 风险统计加载失败", e);
        const isTimeout = e && (e.code === "ECONNABORTED" || /timeout/i.test(e.message || ""));

        this.$message.warning(isTimeout
          ? "风险数据首次加载超时，后台仍在计算，请稍后刷新"
          : "风险数据加载失败，请稍后重试");
      } finally {
        if (!isStale()) {
          this.riskStatsLoading = false;
        }
      }

      if (isStale()) {
        return;
      }

      // ── Part 2：MongoDB 各列表授权依赖概览（独立 try-catch，不影响上方）──
      // allLists：这张表要做列表间横向对比，必须拿到全部 5 个列表的数据，
      // 不能被当前选中的数据源锁成一行。维度筛选仍然生效。
      this.coreMetricsLoading = true;
      try {
        const overviewRes = await axios.get(`${AUTHDEP_MONGO_API}/overview-stats`, {
          params: this.getDashboardParams({}, { allLists: true }),
          timeout: 60000
        });

        if (isStale()) {
          return;
        }

        this.overviewStats = overviewRes.data;
        // 若 MongoDB 有更精确的扫描时间，用它更新 lastScanTime
        if (overviewRes.data.date) {
          const d = overviewRes.data.date; // "2026-03-27"

          this.lastScanTime = `${d.slice(0,4)}年${d.slice(5,7)}月${d.slice(8,10)}日`;
        }
        this.buildListStatsTable();
        this.coreMetricsLoading = false;
        await this.loadTopNodes(seq);
      } catch (e) {
        if (isStale()) {
          return;
        }
        console.warn("[dashboard] MongoDB 概览数据不可用，展示占位行", e.message);
        // 填入占位行（各列表数据均为 '-'），避免列表对比表空白
        this.listStatsTable = DEFINED_LISTS.map(d => ({
          value: d.value,
          mongoName: d.mongoName,
          friendlyName: d.displayLabel,
          count: 0,
          avgDepth: null,
          avgMaxDepth: null
        }));
        this.coreMetricsLoading = false;
      }
    },
    /**
     * 将 overview-stats 返回的 lists 数组转换为 5 行固定顺序的表格数据。
     * 即使某个列表在 MongoDB 中尚无数据，也会显示占位行（count=0, depth='-'）。
     * 按 mongoName 取数（而非按下标），所以后端返回顺序变化不会造成行错位。
     */
    buildListStatsTable() {
      if (!this.overviewStats) {
        return;
      }
      const apiMap = Object.fromEntries(
        (this.overviewStats.lists || []).map(l => [l.name, l])
      );

      this.listStatsTable = DEFINED_LISTS.map(def => {
        const api = apiMap[def.mongoName] || {};

        return {
          value:       def.value,
          mongoName:   def.mongoName,
          friendlyName: def.displayLabel,
          count:       api.count       ?? 0,
          avgDepth:    api.avgDepth    ?? null,
          avgMaxDepth: api.avgMaxDepth ?? null
        };
      });
    },

    /**
     * 加载当前所选列表的 Top 10 关键依赖节点。
     * @param {number} [seq] 调用方的请求序号（来自 loadDashboard）。"全部"模式下这里会
     *   并发发 5 个请求，耗时差异大，没有序号守卫时旧的一批会覆盖新的一批。
     */
    async loadTopNodes(seq = null) {
      const isStale = () => seq !== null && seq !== this._dashSeq;
      const source = this.dashFilter.source;
      const dimensionParams = this.dashFilter.dimension && this.dashFilter.dimension !== "all"
        ? { dimension: this.dashFilter.dimension }
        : {};

      this.topNodesLoading = true;
      this.keyDependencies = [];
      try {
        if (source === "all") {
          // 并发拉取所有列表，合并后按 SLD 累加排序
          const results = await Promise.allSettled(
            DEFINED_LISTS.map(def =>
              axios.get(`${AUTHDEP_MONGO_API}/top-nodes`, {
                params: { list: def.mongoName, limit: 60, ...dimensionParams },
                timeout: 60000
              })
            )
          );

          if (isStale()) {
            return;
          }
          const merged = new Map();

          for (const r of results) {
            if (r.status !== "fulfilled") {
              continue;
            }
            for (const n of (r.value.data.nodes || [])) {
              merged.set(n._id, (merged.get(n._id) || 0) + n.count);
            }
          }
          this.keyDependencies = [...merged.entries()]
            .sort((a, b) => b[1] - a[1])
            .slice(0, 30)
            .map(([domain, count]) => ({ domain, count }));
        } else {
          const def = DEFINED_LISTS.find(d => d.value === source);
          const mongoName = def ? def.mongoName : source;
          const res = await axios.get(`${AUTHDEP_MONGO_API}/top-nodes`, {
            params: { list: mongoName, limit: 30, ...dimensionParams },
            timeout: 60000
          });

          if (isStale()) {
            return;
          }
          this.keyDependencies = (res.data.nodes || []).map(n => ({
            domain: n._id,
            count:  n.count
          }));
        }
      } catch (e) {
        if (isStale()) {
          return;
        }
        console.warn("[dashboard] top-nodes 加载失败", e.message);
      } finally {
        if (!isStale()) {
          this.topNodesLoading = false;
        }
      }
    },

    /** 关键依赖节点气泡图：echarts 力导布局，按被依赖数 sqrt 缩放，无边节点自动散布 */
    renderKeyDepsChart() {
      if (!this.$refs.keyDepsChart || !this.keyDependencies.length) {
        return;
      }
      const echarts = require("echarts");

      if (this.keyDepsChartInstance) {
        this.keyDepsChartInstance.dispose();
      }
      const counts = this.keyDependencies.map(n => n.count || 0);
      const max = Math.max(...counts, 1);
      const min = Math.min(...counts);
      // 气泡尺寸按节点数自适应：节点越多、单个气泡越小，避免画布拥挤
      const nodeCount = this.keyDependencies.length || 1;
      const minSize = nodeCount > 20 ? 32 : (nodeCount > 12 ? 48 : 60);
      const maxSize = nodeCount > 20 ? 96 : (nodeCount > 12 ? 130 : 160);
      const palette = [
        { stop: 0,    rgb: [96, 165, 250] },   // 蓝
        { stop: 0.5,  rgb: [59, 130, 246] },   // 深蓝
        { stop: 0.75, rgb: [245, 158, 11] },   // 橙
        { stop: 1,    rgb: [239, 68, 68] }     // 红
      ];
      const pickColor = ratio => {
        let picked = palette[0].rgb;

        for (let i = palette.length - 1; i >= 0; i--) {
          if (ratio >= palette[i].stop) {
            picked = palette[i].rgb;
            break;
          }
        }
        return picked;
      };
      const data = this.keyDependencies.map(node => {
        const ratio = max === min ? 1 : (Math.sqrt(node.count) - Math.sqrt(min)) / (Math.sqrt(max) - Math.sqrt(min));
        const size = Math.round(minSize + ratio * (maxSize - minSize));
        const [r, g, b] = pickColor(ratio);
        const fontSize = Math.max(11, Math.round(size * 0.18));

        return {
          id: node.domain,
          name: node.domain,
          value: node.count,
          symbolSize: size,
          itemStyle: {
            color: {
              type: "radial",
              x: 0.35,
              y: 0.35,
              r: 0.7,
              colorStops: [
                { offset: 0, color: `rgba(${r},${g},${b},0.95)` },
                { offset: 1, color: `rgba(${r},${g},${b},0.35)` }
              ]
            },
            borderColor: `rgba(${r},${g},${b},0.85)`,
            borderWidth: 1,
            shadowBlur: 14,
            shadowColor: `rgba(${r},${g},${b},0.45)`
          },
          label: {
            show: true,
            color: "#fff",
            fontWeight: 600,
            fontSize,
            formatter: "{b}",
            overflow: "truncate",
            width: size - 8
          }
        };
      });

      this.keyDepsChartInstance = echarts.init(this.$refs.keyDepsChart);

      const cw = this.$refs.keyDepsChart.clientWidth || 600;
      const ch = this.$refs.keyDepsChart.clientHeight || 400;
      const sizes = data.map(d => d.symbolSize);
      const avgSize = sizes.reduce((s, x) => s + x, 0) / sizes.length;
      const totalBubbleArea = sizes.reduce((s, sz) => s + Math.PI * (sz / 2) ** 2, 0);
      const fillRatio = totalBubbleArea / (cw * ch);
      // repulsion 设到大于平均气泡直径，确保两个气泡边缘有间距而不是叠加；
      // gravity 取小值，让斥力主导布局填满 canvas，而不是被中心引力拉成一团
      const repulsion = Math.round(avgSize * 4);
      const gravity = fillRatio < 0.18 ? 0.18 : (fillRatio < 0.32 ? 0.12 : 0.08);

      this.keyDepsChartInstance.setOption({
        backgroundColor: "transparent",
        tooltip: {
          trigger: "item",
          formatter: params => `${params.data.name}<br/>被依赖：<b>${Number(params.data.value).toLocaleString()}</b>`,
          backgroundColor: "rgba(15,23,42,0.92)",
          borderColor: "rgba(96,165,250,0.4)",
          textStyle: { color: "#e2eeff", fontSize: 12 }
        },
        series: [{
          type: "graph",
          layout: "force",
          data,
          links: [],
          roam: true,
          draggable: true,
          force: {
            repulsion,
            gravity,
            edgeLength: 0,
            friction: 0.22,
            layoutAnimation: true
          },
          emphasis: { scale: 1.08, focus: "self" },
          labelLayout: { hideOverlap: false }
        }]
      });
      if (!this._keyDepsResizeBound) {
        this._keyDepsResizeHandler = () => {
          if (this.keyDepsChartInstance) {
            this.keyDepsChartInstance.resize();
          }
        };
        window.addEventListener("resize", this._keyDepsResizeHandler);
        this._keyDepsResizeBound = true;
      }
    },

    listRowClass({ row }) {
      if (this.dashFilter.source === "all") {
        return "";
      }
      return row.value === this.dashFilter.source ? "list-row-active" : "";
    },

    stateLabel(state) {
      if (state === "has_risk") {
        return "有风险";
      }
      if (state === "no_risk") {
        return "无风险";
      }
      return "未探测";
    },
    async doCompanyQuery(page) {
      const keyword = (this.companySearch || "").trim();

      if (!keyword) {
        this.$message.warning("请输入机构名称"); return;
      }
      this.queryLoading = true;
      this.selectedQueryRow = null;
      this.expandedRowKeys = [];
      this.disposeAllQueryDepCharts();

      this.isLoading = true;
      this.loadingText = `正在查询 ${keyword} 关联域名...`;

      try {
        // 1. 实体查询（模糊匹配，拿到标准名称）
        const [entityInfoRes, domainListRes] = await Promise.all([
          getEntityInfo({ 实体名或关键词: keyword }),
          getDomainAuthRiskList({ 实体名或关键词: keyword })
        ]);

        if (
          !(entityInfoRes && entityInfoRes.code === 200)
          || !entityInfoRes.data
          || !(domainListRes && domainListRes.code === 200)
          || !domainListRes.data
          || !(domainListRes.data.域名 || []).length
        ) {
          this.$message.warning("该机构不在监测范围内或暂无关联域名");
          this.queryTableData = [];
          this.companyQueryTotal = 0;
          return;
        }

        const standardName = entityInfoRes.data.实体规范名称 || keyword;

        this.companySearch = standardName;
        const allDomains = (domainListRes.data.域名 || []).map(d => String(d || "").trim().toLowerCase().replace(/\.$/, "")).filter(Boolean);
        const uniqueDomains = [...new Set(allDomains)];

        // 拉全量归属机构（带缓存），按机构签名排序，让相同机构的域名跨页相邻
        const cacheKey = `${standardName}|${this.companyQueryDate || ""}|${uniqueDomains.length}`;

        let sortedDomains;

        let fullCompanyMap;

        if (this._companySortCacheKey === cacheKey && this._companySortedDomains) {
          sortedDomains = this._companySortedDomains;
          fullCompanyMap = this._companyFullMap;
        } else {
          fullCompanyMap = await this.fetchDomainCompaniesBatch(uniqueDomains);
          const sigOf = d => ((fullCompanyMap[d] || []).slice().sort().join("||")) || "~";

          sortedDomains = uniqueDomains.slice().sort((a, b) => {
            const sa = sigOf(a);
            const sb = sigOf(b);

            if (sa !== sb) {
              return sa.localeCompare(sb);
            }
            return a.localeCompare(b);
          });
          this._companySortCacheKey = cacheKey;
          this._companySortedDomains = sortedDomains;
          this._companyFullMap = fullCompanyMap;
        }

        this.companyQueryTotal = sortedDomains.length;
        this.companyQueryPage = page || 1;

        // 2. 分页切片
        const start = (this.companyQueryPage - 1) * this.companyQuerySize;
        const pagedDomains = sortedDomains.slice(start, start + this.companyQuerySize);

        // 占位行（机构已经全量拿到，直接填；风险并发补齐）
        this.queryTableData = pagedDomains.map((domain, i) => ({
          id: String(start + i + 1).padStart(3, "0"),
          domain,
          companies: fullCompanyMap[domain] || [],
          companiesLoading: false,
          state: "loading",
          severity: "",
          riskType: [],
          discoveryTime: "",
          verifyTimeActive: "",
          verifyTimeManual: "",
          evidence: [],
          recommendation: "",
          priorityBasis: "",
          taskType: "",
          runId: "",
          sourceRunId: "",
          confirmLevel: "",
          depGraphTime: "",
          depGraphLoading: false,
          depGraphEmpty: false,
          depGraphLoaded: false,
          rawData: null
        }));

        // 3. 仅对当前页查风险状态（机构已全量获取，无需再查）
        const dateForRisk = this.companyQueryDate || "";
        const { map: riskMap, date: riskBatchDate } = await this.fetchDomainRisksBatch(pagedDomains, dateForRisk);

        this.queryTableData = this.queryTableData.map(row => {
          const risk = riskMap[row.domain] || { state: "not_probed" };
          const decoratedRow = {
            ...row,
            state: risk.state,
            batchDate: riskBatchDate || this.companyQueryDate || ""
          };

          if (risk.state === "has_risk") {
            decoratedRow.severity = risk.severity || "";
            decoratedRow.riskType = risk.risk_labels || (risk.risk_types || []).map(t => this.riskLabel(t));
            decoratedRow.evidence = risk.evidence_summary || [];
            decoratedRow.recommendation = risk.recommendation || "";
            decoratedRow.priorityBasis = risk.priority_basis || "";
            decoratedRow.taskType = risk.task_type || "";
            decoratedRow.runId = risk.run_id || "";
            decoratedRow.sourceRunId = risk.source_run_id || "";
            decoratedRow.confirmLevel = this.confirmLabel(risk.confirm_level);
            const cs = risk.check_status || {};

            decoratedRow.discoveryTime = cs.passive_time ? cs.passive_time.slice(0, 10) : (this.companyQueryDate || "");
            decoratedRow.verifyTimeActive = cs.active_time ? cs.active_time.slice(0, 10) : "";
            decoratedRow.verifyTimeManual = cs.manual_time || "";
            decoratedRow.rawData = risk;
          }
          return decoratedRow;
        });
      } catch (e) {
        console.error("[doCompanyQuery] 查询失败", e);
        const isTimeout = e && (e.code === "ECONNABORTED" || /timeout/i.test(e.message || ""));

        this.$message.error(isTimeout ? "查询超时，请稍后重试" : "查询失败：" + (e.message || "网络错误"));
        this.queryTableData = [];
        this.companyQueryTotal = 0;
      } finally {
        this.isLoading = false;
        this.loadingText = "";
        this.queryLoading = false;
      }
    },
    async fetchDomainCompaniesBatch(domains) {
      const map = {};

      if (!domains.length) {
        return map;
      }
      const chunkSize = 1000;
      const chunks = [];

      for (let i = 0; i < domains.length; i += chunkSize) {
        chunks.push(domains.slice(i, i + chunkSize));
      }
      try {
        const responses = await Promise.all(chunks.map(chunk => getDomainCompanyBatch(chunk)));

        for (const res of responses) {
          if (res && res.result) {
            for (const [domain, companies] of Object.entries(res.result)) {
              const key = domain.toLowerCase().replace(/\.$/, "");

              map[key] = Array.isArray(companies) ? companies : [];
            }
          }
        }
      } catch (e) {
        console.warn("[doCompanyQuery] 批量归属机构查询失败", e.message);
      }
      return map;
    },
    async fetchDomainRisksBatch(domains, date) {
      const map = {};

      let batchDate = "";

      if (!domains.length) {
        return { map, date: batchDate };
      }
      try {
        const res = await axios.post(`${AUTHDEP_MONGO_API}/risks-by-domains`, {
          domains,
          date: date || undefined
        }, {
          timeout: 60000,
          headers: { "Content-Type": "application/json" }
        });

        batchDate = (res.data && res.data.date) || "";
        const statusMap = (res.data && res.data.status_map) || {};

        for (const [domain, info] of Object.entries(statusMap)) {
          const key = domain.toLowerCase().replace(/\.$/, "");

          map[key] = info;
        }
      } catch (e) {
        console.warn("[doCompanyQuery] 批量风险查询失败", e.message);
      }
      return { map, date: batchDate };
    },
    parseCompanyRiskToTable() {
      return [];
    },
    async doQuery() {
      if (!this.querySearch.trim()) {
        return;
      }
      this.queryLoading = true;
      this.selectedQueryRow = null;
      this.expandedRowKeys = [];
      this.disposeAllQueryDepCharts();
      try {
        // 优先查 MongoDB
        const domain = this.querySearch.trim().toLowerCase();
        const mongoRes = await axios.get(`${AUTHDEP_MONGO_API}/risk-cases`, {
          params: { source: "all", q: domain, size: 100 }, timeout: 60000
        });
        const matched = (mongoRes.data.cases || []).filter(d => d.domain === domain || d.domain.endsWith("." + domain));

        if (matched.length > 0) {
          let rows = matched.map((doc, i) => {
            const cs = doc.check_status || {};
            const riskLabels = (doc.risk_labels && doc.risk_labels.length)
              ? doc.risk_labels
              : (doc.risk_types || []).map(t => this.riskLabel(t));

            return {
              id: String(i + 1).padStart(3, "0"),
              domain: doc.domain,
              companies: null,
              companiesLoading: true,
              state: "has_risk",
              severity: doc.severity || "",
              riskType: riskLabels,
              evidence: doc.evidence_summary || [],
              recommendation: doc.recommendation || "",
              priorityBasis: doc.priority_basis || "",
              taskType: doc.task_type || "",
              runId: doc.run_id || "",
              sourceRunId: doc.source_run_id || "",
              confirmLevel: this.confirmLabel(cs.confirm_level || doc.confirm_level),
              discoveryTime: cs.passive_time ? cs.passive_time.slice(0, 10) : (mongoRes.data.run_id ? `${mongoRes.data.run_id.slice(0,4)}-${mongoRes.data.run_id.slice(4,6)}-${mongoRes.data.run_id.slice(6,8)}` : ""),
              verifyTimeActive: cs.active_time ? cs.active_time.slice(0, 10) : "",
              verifyTimeManual: cs.manual_time || "",
              depGraphTime: "",
              depGraphLoading: false,
              depGraphEmpty: false,
              depGraphLoaded: false,
              rawData: doc
            };
          });

          if (this.domainQueryType) {
            rows = rows.filter(r => r.riskType.includes(this.domainQueryType));
          }
          this.queryTableData = rows;

          // 异步补充归属机构
          const allDomains = rows.map(r => r.domain);

          this.fetchDomainCompaniesBatch(allDomains).then(map => {
            this.queryTableData = this.queryTableData.map(row => ({
              ...row,
              companies: map[row.domain.toLowerCase().replace(/\.$/, "")] || [],
              companiesLoading: false
            }));
          });
          return;
        }
        // risk-cases 只收录"有风险"的域名，查不到不代表没探测过。
        // 再用 /risks-by-domains（精确域名）查该域名真实状态，区分三态：
        //   no_risk    探测过、未发现风险 → 显示绿色"已探测无风险"
        //   not_probed 从未探测过       → 提示可实时探测
        try {
          const stRes = await axios.post(`${AUTHDEP_MONGO_API}/risks-by-domains`, {
            domains: [domain],
            date: this.currentDashboardDate || undefined
          }, {
            timeout: 30000,
            headers: { "Content-Type": "application/json" }
          });
          const st = ((stRes.data || {}).status_map || {})[domain] || {};

          if (st.state === "no_risk") {
            this.queryTableData = [{
              id: "001",
              domain,
              companies: null,
              companiesLoading: true,
              state: "no_risk",
              severity: "",
              riskType: [],
              evidence: [],
              recommendation: "",
              priorityBasis: "",
              taskType: "",
              runId: stRes.data.run_id || "",
              sourceRunId: "",
              confirmLevel: "",
              discoveryTime: stRes.data.date || "",
              verifyTimeActive: "",
              verifyTimeManual: "",
              depGraphTime: "",
              depGraphLoading: false,
              depGraphEmpty: false,
              depGraphLoaded: false,
              rawData: null
            }];
            this.fetchDomainCompaniesBatch([domain]).then(map => {
              this.queryTableData = this.queryTableData.map(row => ({
                ...row,
                companies: map[row.domain.toLowerCase().replace(/\.$/, "")] || [],
                companiesLoading: false
              }));
            });
            return;
          }
        } catch (stErr) {
          // 状态补查失败不阻断主流程，退回原"暂无记录"提示
          console.warn("[query] risks-by-domains 状态补查失败", stErr && stErr.message);
        }

        // 确认从未探测过（或状态补查失败）：提示可切换实时探测
        this.$message({
          message: "该域名暂无探测记录，可点击\"实时探测\"发起主动检测",
          type: "warning",
          duration: 5000
        });
        this.queryTableData = [];
      } catch (e) {
        const isTimeout = e && (e.code === "ECONNABORTED" || /timeout/i.test(e.message || ""));

        if (isTimeout) {
          this.$message.warning("MongoDB 查询超时，后台仍在计算，请稍后再点\"查询\"重试");
          this.queryTableData = [];
        } else {
          // 真正的网络/服务故障才降级到实时探测
          this.$message.warning("MongoDB 查询失败，已切换实时探测模式");
          await this.doQueryRealtime();
        }
      } finally {
        this.queryLoading = false;
      }
    },
    async doQueryRealtime() {
      if (!this.querySearch.trim()) {
        return;
      }
      this.queryLoading = true;
      this.selectedQueryRow = null;
      this.expandedRowKeys = [];
      this.disposeAllQueryDepCharts();
      this.isLoading = true;
      this.loadingStepIndex = 0;
      this.loadingText = this.loadingSteps[0];
      this.loadingTimer = setInterval(() => {
        this.loadingStepIndex = (this.loadingStepIndex + 1) % this.loadingSteps.length;
        this.loadingText = this.loadingSteps[this.loadingStepIndex];
      }, 2000);
      try {
        const res = await axios.post(`${AUTH_DEP_API}/risk`, { domain: this.querySearch.trim() }, { timeout: 180000, headers: AUTH_DEP_HEADERS });

        let rows = this.parseRiskToTable(res.data, this.querySearch.trim());

        if (this.domainQueryType) {
          rows = rows.filter(r => r.riskType && r.riskType.includes(this.domainQueryType));
        }
        this.queryTableData = rows;
      } catch (e) {
        this.$message.error("查询失败：" + (e.message || "网络错误"));
        this.queryTableData = [];
      } finally {
        clearInterval(this.loadingTimer);
        this.loadingTimer = null;
        this.isLoading = false;
        this.queryLoading = false;
      }
    },
    parseRiskToTable(data, domain) {
      // 后端返回 {'0': {...}} 或数组
      let item;

      if (Array.isArray(data)) {
        item = data[0];
      } else if (data && data["0"]) {
        item = data["0"];
      } else {
        item = data;
      }
      if (!item) {
        return [];
      }
      // 用 risk code 收集，再统一映射中文名与优先级（与后端 RISK_META 对齐，避免硬编码 P2）
      const riskCodes = [];

      if (item.dangling_records && item.dangling_records.length) {
        riskCodes.push("dangling_ns");
      }
      if (item.lame_delegation && item.lame_delegation.length) {
        riskCodes.push("lame");
      }
      if (item.loop_nameserver && item.loop_nameserver.length) {
        riskCodes.push("loop");
      }
      if (item.orphan_nameserver && item.orphan_nameserver.length) {
        riskCodes.push("orphan");
      }
      if (item.consistent_ns === false) {
        riskCodes.push("inconsistency");
      }
      const riskTypes = riskCodes.map(c => RISK_LABELS[c] || c);
      const today = new Date().toISOString().slice(0, 10);

      return [{
        id: "001",
        domain: (item.domain || domain).replace(/\.$/, ""),
        companies: null,
        companiesLoading: true,
        state: riskCodes.length ? "has_risk" : "no_risk",
        severity: riskCodes.length ? this.severityOf(riskCodes) : "",
        riskType: riskTypes,
        evidence: [],
        recommendation: "",
        priorityBasis: "",
        taskType: "实时探测",
        runId: "",
        sourceRunId: "",
        confirmLevel: "",
        discoveryTime: today,
        verifyTimeActive: today,
        verifyTimeManual: "",
        depGraphTime: "",
        depGraphLoading: false,
        depGraphEmpty: false,
        depGraphLoaded: false,
        rawData: item
      }];
    },
    toggleDepGraph(id) {
      const idx = this.expandedRowKeys.indexOf(id);

      if (idx >= 0) {
        this.expandedRowKeys = this.expandedRowKeys.filter(k => k !== id);
        this.disposeQueryDepChart(id);
        return;
      }
      this.expandedRowKeys = [...this.expandedRowKeys, id];
      this.$nextTick(() => this.loadAndRenderQueryDepGraph(id));
    },
    handleQueryExpandChange(row, expandedRows) {
      const visibleIds = new Set((expandedRows || []).map(r => r.id));
      const wasExpanded = this.expandedRowKeys.includes(row.id);
      const isExpanded = visibleIds.has(row.id);

      this.expandedRowKeys = (expandedRows || []).map(r => r.id);
      if (!isExpanded && wasExpanded) {
        this.disposeQueryDepChart(row.id);
        return;
      }
      if (isExpanded && !wasExpanded) {
        this.$nextTick(() => this.loadAndRenderQueryDepGraph(row.id));
      }
    },
    handleQueryRowClick(row) {
      this.toggleDepGraph(row.id);
    },
    disposeQueryDepChart(id) {
      const inst = this.queryDepChartInstances[id];

      if (inst) {
        inst.dispose();
        delete this.queryDepChartInstances[id];
      }
    },
    disposeAllQueryDepCharts() {
      for (const id of Object.keys(this.queryDepChartInstances)) {
        try {
          this.queryDepChartInstances[id].dispose();
        } catch (_) { /* ignore */ }
      }
      this.queryDepChartInstances = {};
    },
    async loadAndRenderQueryDepGraph(id) {
      const row = this.queryTableData.find(r => r.id === id);

      if (!row) {
        return;
      }
      const idx = this.queryTableData.indexOf(row);

      if (idx < 0) {
        return;
      }

      // 已有数据，直接重渲
      if (row.depGraphLoaded && row.rawDepGraph) {
        this.$nextTick(() => this.renderQueryDepChartIntoRef(id, row.rawDepGraph, "general"));
        return;
      }

      this.$set(this.queryTableData, idx, { ...row, depGraphLoading: true, depGraphEmpty: false });
      const date = row.batchDate || this.companyQueryDate || (row.discoveryTime || "").slice(0, 10);

      try {
        const res = await axios.get(`${AUTHDEP_MONGO_API}/dep-graph`, {
          params: { domain: row.domain, date, mode: "general" },
          timeout: 30000
        });
        const doc = res.data.graph || res.data;
        const resData = doc.dependency_graphs ? doc : { domain: doc.domain || row.domain, nsChain: doc.nodes || [] };
        const hasData = resData.dependency_graphs
          ? Object.values(resData.dependency_graphs).some(g => g
              && ((g.links || g.edges || []).length > 0 || (g.nodes || []).length > 0))
          : (resData.nsChain || []).length > 0;

        if (!hasData) {
          this.$set(this.queryTableData, idx, { ...this.queryTableData[idx], depGraphLoading: false, depGraphEmpty: true, depGraphLoaded: true });
          return;
        }
        this.$set(this.queryTableData, idx, {
          ...this.queryTableData[idx],
          depGraphLoading: false,
          depGraphEmpty: false,
          depGraphLoaded: true,
          depGraphTime: date,
          rawDepGraph: resData
        });
        this.$nextTick(() => this.renderQueryDepChartIntoRef(id, resData, "general"));
      } catch (e) {
        const empty = e.response && e.response.status === 404;

        this.$set(this.queryTableData, idx, { ...this.queryTableData[idx], depGraphLoading: false, depGraphEmpty: true, depGraphLoaded: true });
        if (!empty) {
          this.$message.warning("获取依赖图失败");
        }
      }
    },
    renderQueryDepChartIntoRef(id, data, level) {
      const refKey = `queryDepChart_${id}`;
      const el = this.$refs[refKey];
      const target = Array.isArray(el) ? el[0] : el;

      if (!target) {
        return;
      }
      const echarts = require("echarts");

      this.disposeQueryDepChart(id);
      const row = this.queryTableData.find(r => r.id === id);
      const riskInfo = row ? this.collectRiskNsSet(row) : null;
      const { nodes, edges } = this.buildGraphData(data, level, riskInfo);

      if (!nodes.length) {
        return;
      }
      const inst = echarts.init(target);

      inst.setOption(this.buildGraphOption(nodes, edges));
      this.queryDepChartInstances[id] = inst;
    },
    renderQueryDepChart() {},
    renderQueryDepChartFromData(data, level) {
      if (!this.$refs.queryDepChart) {
        return;
      }
      const echarts = require("echarts");

      if (this.queryDepChartInstance) {
        this.queryDepChartInstance.dispose();
      }
      const { nodes, edges } = this.buildGraphData(data, level);

      if (!nodes.length) {
        this.$message.warning("该域名暂无依赖关系数据"); return;
      }
      this.queryDepChartInstance = echarts.init(this.$refs.queryDepChart);
      this.queryDepChartInstance.setOption(this.buildGraphOption(nodes, edges));
    },
    async doTrace() {
      if (!this.traceSearch.trim()) {
        return;
      }
      this.traceLoading = true;
      try {
        const date = this.traceDate || (this.lastScanTime
          ? this.lastScanTime.replace("年","-").replace("月","-").replace("日","")
          : new Date().toISOString().slice(0, 10));
        // 20260401 之前走原有后端，之后走 MongoDB
        const useMongoBackend = date >= "2026-04-01";

        let resData;

        if (useMongoBackend) {
          const res = await axios.get(`${AUTHDEP_MONGO_API}/dep-graph`, {
            params: { domain: this.traceSearch.trim(), date, mode: this.traceDepLevel || "general" },
            timeout: 60000
          });
          // MongoDB dep-graph 返回 dependency_graphs 兼容格式
          const doc = res.data.graph || res.data;

          resData = doc.dependency_graphs ? doc : { domain: doc.domain, nsChain: doc.nodes || [] };
        } else {
          const res = await axios.post(`${AUTH_DEP_API}/historical-domainrelation`, { input: this.traceSearch.trim(), date }, { timeout: 180000, headers: AUTH_DEP_HEADERS });

          resData = res.data;
        }
        console.log("[trace] response:", JSON.stringify(resData).slice(0, 300));
        this.$nextTick(() => this.renderTraceChart(resData, this.traceDepLevel));
      } catch (e) {
        if (e.response && e.response.status === 404) {
          this.$message.warning("该域名在所选日期暂无历史数据（404）");
        } else {
          this.$message.error("查询失败：" + (e.message || "网络错误"));
        }
      } finally {
        this.traceLoading = false;
      }
    },
    renderTraceChart(data, level) {
      if (!this.$refs.traceChart) {
        return;
      }
      const echarts = require("echarts");

      if (this.traceChartInstance) {
        this.traceChartInstance.dispose();
      }
      const { nodes, edges } = this.buildGraphData(data, level);

      if (!nodes.length) {
        this.$message.warning("该域名在所选日期暂无依赖关系数据");
        return;
      }
      this.traceChartInstance = echarts.init(this.$refs.traceChart);
      this.traceChartInstance.setOption(this.buildGraphOption(nodes, edges));
    },
    /**
     * 从风险行的原始数据 + 证据摘要里收集"风险 NS"集合（含主机名和 IP）。
     * - 优先使用 rawData.active 里的精确字段（dangling_nameserver / lame_delegation / orphan / zombie）
     * - 同时解析 evidence_summary 文本里的 NS（兜底，避免 rawData 缺失）
     * 返回 { riskSet: Set<string>, labelMap: Map<string, string[]> }，键统一小写去尾点。
     */
    collectRiskNsSet(row) {
      const riskSet = new Set();
      const labelMap = new Map();
      const norm = v => String(v || "").trim().toLowerCase().replace(/\.$/, "");
      // 占位符黑名单：后端证据摘要对空列表用 "-" 等占位，不能当成真实 NS 节点
      const PLACEHOLDER = new Set(["-", "--", "—", "unknown", "n/a", "~no_pdns_data~"]);
      const add = (value, label) => {
        const key = norm(value);

        // 必须是非空、非占位符、且形如域名（含点）的 token 才标红，
        // 避免 "-" 等占位符或非域名文本被当成风险 NS 节点。
        if (!key || PLACEHOLDER.has(key) || !key.includes(".")) {
          return;
        }
        riskSet.add(key);
        if (label) {
          const arr = labelMap.get(key) || [];

          if (!arr.includes(label)) {
            arr.push(label);
          }
          labelMap.set(key, arr);
        }
      };

      // 只从 rawData.active 的精确字段收集"真正有问题的 NS 主机名"。
      // 不再从 evidence_summary 文本兜底解析，因为那会把 NS不一致 证据里
      // 仅作为"比较对象"的父侧/子侧 NS 也全部标红，造成大量误报。
      const active = (row.rawData && row.rawData.active) || {};
      const domainKey = norm(row.domain);
      const fieldLabel = [
        ["dangling_nameserver", "悬空NS记录"],
        ["lame_delegation", "跛脚委派"],
        ["orphan_nameserver_active", "孤儿NS"],
        ["zombie_nameserver", "僵尸NS记录"]
      ];

      for (const [field, label] of fieldLabel) {
        for (const v of (active[field] || [])) {
          add(v, label);
        }
      }

      // 循环授权：标链路上的 NS，但跳过被查域名自身（真正有问题的是 NS 递归链，
      // 把根域名标红会误导用户以为该域名本体有问题）。
      for (const v of (active.active_loop_nameserver || [])) {
        if (norm(v) !== domainKey) {
          add(v, "循环授权");
        }
      }

      // NS记录不一致：只标父子侧的"对称差"——即只出现在一侧而另一侧没有的 NS。
      // 两侧都有的交集 NS 是正常的，不标红。
      if (active.consistent_ns === false) {
        const pSet = new Set((active.pNSset || []).map(norm));
        const cSet = new Set((active.cNSset || []).map(norm));

        for (const ns of pSet) {
          if (!cSet.has(ns)) {
            add(ns, "NS记录不一致");
          }
        }
        for (const ns of cSet) {
          if (!pSet.has(ns)) {
            add(ns, "NS记录不一致");
          }
        }
      }
      return { riskSet, labelMap };
    },
    /**
     * 判断给定字符串是否为 IPv4 / IPv6 字面量。依赖图节点应仅展示域名层级，
     * IP 是 NS 解析出的 A/AAAA 记录，混入会让"授权依赖图"语义错位。
     */
    isIpLiteral(value) {
      const s = String(value || "").trim();

      if (!s) {
        return false;
      }
      // IPv4: 1-3 位数字组成的四段
      if (/^\d{1,3}(\.\d{1,3}){3}$/.test(s)) {
        return true;
      }
      // IPv6: 含冒号且只由 hex/冒号/点（IPv4-mapped）组成
      if (s.includes(":") && /^[0-9a-fA-F:.]+$/.test(s)) {
        return true;
      }
      return false;
    },
    buildGraphData(data, level, riskInfo) {
      const nodes = [];
      const edges = [];

      if (!data) {
        return { nodes, edges };
      }

      const colorMap = { root: "#f59e0b", domain: "#3b82f6", ns: "#22c55e" };
      const sizeMap = { root: 50, domain: 35, ns: 28 };
      const norm = v => String(v || "").trim().toLowerCase().replace(/\.$/, "");
      const riskSet = (riskInfo && riskInfo.riskSet) || new Set();
      const labelMap = (riskInfo && riskInfo.labelMap) || new Map();
      const nodeMap = {};
      const isIp = v => this.isIpLiteral(v);

      const addNode = (id, type) => {
        // 过滤 IP 字面量：依赖图只展示域名层级
        if (!id || isIp(id)) {
          return false;
        }
        if (!nodeMap[id]) {
          const isRisk = riskSet.has(norm(id));
          const labels = labelMap.get(norm(id)) || [];
          const n = {
            id,
            name: id,
            symbolSize: (sizeMap[type] || 30) + (isRisk ? 6 : 0),
            itemStyle: isRisk
              ? { color: "#ef4444", borderColor: "#fca5a5", borderWidth: 2, shadowBlur: 12, shadowColor: "rgba(239,68,68,0.6)" }
              : { color: colorMap[type] || "#94a3b8", borderColor: "#1e3a5f", borderWidth: 2 },
            label: { show: true, color: isRisk ? "#fff" : "#C1D5FF", fontSize: 11, fontWeight: isRisk ? 600 : 400 },
            _type: type,
            _isRisk: isRisk,
            _riskLabels: labels
          };

          nodeMap[id] = n;
          nodes.push(n);
        }
        return true;
      };

      const rawEdges = [];

      const graphData = data.general || data.explicit || data;

      if (data.dependency_graphs) {
        const g = data.dependency_graphs[level || "general"] || data.dependency_graphs.general || {};
        const nodeIndegree = {};

        (g.nodes || []).forEach(n => {
          nodeIndegree[n.id] = n.indegree;
        });
        (g.links || g.edges || []).forEach(e => {
          if (isIp(e.source) || isIp(e.target)) {
            return;
          }
          const isParentChild = e.source.endsWith("." + e.target) || e.target === ".";
          const ind = nodeIndegree[e.source];

          addNode(e.source, ind === 0 ? "root" : "domain");
          addNode(e.target, "ns");
          rawEdges.push({ source: e.source, target: e.target, isParentChild });
        });
      } else if (graphData && graphData.nodes) {
        graphData.nodes.forEach(n => addNode(n.id || n.name, n.type || "domain"));
        (graphData.edges || graphData.links || []).forEach(e => {
          if (isIp(e.source) || isIp(e.target)) {
            return;
          }
          addNode(e.source, "domain"); addNode(e.target, "ns");
          rawEdges.push({ source: e.source, target: e.target, isParentChild: false });
        });
      } else if (data.nsChain) {
        // MongoDB nodes 是依赖链，按顺序连接成链式图——过滤 IP 后再连边
        const chain = [data.domain || "root", ...data.nsChain].filter(n => n && !isIp(n));

        chain.forEach((n, i) => {
          addNode(n, i === 0 ? "root" : (i === chain.length - 1 ? "ns" : "domain"));
          if (i > 0) {
            rawEdges.push({ source: chain[i - 1], target: chain[i], isParentChild: false });
          }
        });
      } else if (data.pNSset || data.cNSset) {
        const domain = data.domain || "root";

        addNode(domain, "root");
        (data.pNSset || []).forEach(ns => {
          if (isIp(ns)) {
            return;
          }
          addNode(ns, "ns"); rawEdges.push({ source: domain, target: ns, isParentChild: false });
        });
        (data.cNSset || []).forEach(ns => {
          if (isIp(ns)) {
            return;
          }
          addNode(ns, "ns"); rawEdges.push({ source: domain, target: ns, isParentChild: false });
        });
      }

      // ── 风险 NS 挂载 ──────────────────────────────────────────────
      // 风险来自 collectRiskNsSet：常见的是具体 NS 主机名（如 ns1.example.com）
      // 这些 NS 通常不在常规依赖图里，需要追加为新节点，并以红色虚线无向边
      // 挂到它们的父域名下。挂点优先用"后缀最长匹配"的现有节点，否则挂到图根。
      if (riskSet.size) {
        const existingIds = Object.keys(nodeMap);
        const baseRoot = (data && data.domain) ? norm(data.domain) : (existingIds[0] || "");
        const findParent = nsName => {
          const lower = norm(nsName);

          let best = "";

          for (const id of existingIds) {
            const idLower = norm(id);

            if (idLower === lower) {
              continue;
            }
            if (lower.endsWith("." + idLower) && idLower.length > best.length) {
              best = idLower;
            }
          }
          if (best) {
            return existingIds.find(id => norm(id) === best) || best;
          }
          return baseRoot;
        };

        for (const riskKey of riskSet) {
          if (!riskKey || isIp(riskKey)) {
            continue;
          }
          // 已经在依赖图里出现过的节点直接跳过——它们会通过 addNode 内部的 isRisk 命中而标红
          if (nodeMap[riskKey]) {
            continue;
          }
          if (addNode(riskKey, "ns")) {
            const parent = findParent(riskKey);

            if (parent && parent !== riskKey) {
              rawEdges.push({
                source: parent,
                target: riskKey,
                isParentChild: false,
                isRiskNs: true
              });
            }
          }
        }
      }

      // BFS 分层，计算固定坐标
      // 找根节点（indegree=0 或 type=root）
      const outEdges = {};

      rawEdges.forEach(e => {
        (outEdges[e.source] = outEdges[e.source] || []).push(e.target);
      });
      const inDeg = {};

      nodes.forEach(n => {
        inDeg[n.id] = 0;
      });
      rawEdges.forEach(e => {
        inDeg[e.target] = (inDeg[e.target] || 0) + 1;
      });
      const roots = nodes.filter(n => inDeg[n.id] === 0).map(n => n.id);

      if (!roots.length && nodes.length) {
        roots.push(nodes[0].id);
      }

      // BFS 分层
      const layerOf = {};
      const queue = roots.map(r => {
        layerOf[r] = 0; return r;
      });

      let qi = 0;

      while (qi < queue.length) {
        const cur = queue[qi++];

        (outEdges[cur] || []).forEach(t => {
          if (layerOf[t] === undefined) {
            layerOf[t] = layerOf[cur] + 1; queue.push(t);
          }
        });
      }
      nodes.forEach(n => {
        if (layerOf[n.id] === undefined) {
          layerOf[n.id] = 0;
        }
      });

      // 按层分组
      const layers = {};

      nodes.forEach(n => {
        const l = layerOf[n.id];

        (layers[l] = layers[l] || []).push(n.id);
      });

      // 分配坐标：x 按层（向右），y 按层内位置（居中）
      const xStep = 220;
      const yStep = 100;

      nodes.forEach(n => {
        const layer = layerOf[n.id];
        const group = layers[layer];
        const idx = group.indexOf(n.id);
        const total = group.length;

        n.x = layer * xStep;
        n.y = (idx - (total - 1) / 2) * yStep;
        n.fixed = true;
      });

      // 构建最终 edges：
      // - 父子域：绿色虚线横向
      // - NS授权：蓝色实线斜向
      // - 风险NS（新挂的具体 ns 主机名）：红色虚线、无方向（两端无箭头），标签"风险NS"
      rawEdges.forEach(e => {
        if (e.isRiskNs) {
          edges.push({
            source: e.source,
            target: e.target,
            symbol: ["none", "none"],
            lineStyle: { color: "#ef4444", width: 1.8, type: "dashed", curveness: 0.15, opacity: 0.9 },
            label: { show: true, formatter: "风险NS", fontSize: 10, color: "#fca5a5" }
          });
          return;
        }
        edges.push({
          source: e.source,
          target: e.target,
          lineStyle: e.isParentChild
            ? { color: "#22c55e", width: 1.5, type: "dashed", curveness: 0 }
            : { color: "#60a5fa", width: 2, type: "solid", curveness: 0.25 },
          label: { show: true, formatter: e.isParentChild ? "父子域" : "NS授权", fontSize: 10, color: e.isParentChild ? "#22c55e" : "#60a5fa" }
        });
      });

      return { nodes, edges };
    },
    buildGraphOption(nodes, edges) {
      return {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "item",
          formatter: params => {
            if (params.dataType === "edge") {
              return "";
            }
            const d = params.data || {};
            const name = d.name || params.name || "";

            if (d._isRisk) {
              const labels = (d._riskLabels || []).join("、") || "风险节点";

              return `<b style="color:#fca5a5">${name}</b><br/>风险：${labels}`;
            }
            return name;
          }
        },
        series: [{
          type: "graph",
          layout: "none",
          data: nodes,
          edges,
          roam: true,
          edgeSymbol: ["none", "arrow"],
          edgeSymbolSize: 8,
          lineStyle: { opacity: 0.8 },
          emphasis: { focus: "adjacency" },
          edgeLabel: { show: true, fontSize: 10 }
        }]
      };
    },
    exportReport() {
      this.$message.info("导出功能开发中");
    },
    handleRiskCaseClick(row) {
      this.activeTab = "riskquery";
      this.searchMode = "domain";
      this.querySearch = row.domain;
      this.isLoading = true;
      this.loadingText = `正在查询 ${row.domain} 风险详情...`;
      this.$nextTick(async () => {
        try {
          await this.doQuery();
        } finally {
          this.isLoading = false;
          this.loadingText = "";
        }
      });
    },
    handleRiskCaseRowExpand(row) {
      const tbl = this.$refs.riskCasesTable;

      if (tbl && typeof tbl.toggleRowExpansion === "function") {
        tbl.toggleRowExpansion(row);
      }
    },
    async loadAvailableDates() {
      const MONGO_CUTOFF = "2026-04-01";
      // 将 YYYYMMDD 或 YYYY-MM-DD 统一转为 YYYY-MM-DD
      const toIso = d => d.length === 8 ? `${d.slice(0,4)}-${d.slice(4,6)}-${d.slice(6,8)}` : d;

      try {
        // 旧后端：返回 YYYYMMDD，转换后只取 < 2026-04-01 的日期
        const legacyRes = await axios.get(`${AUTH_DEP_API}/available-dates`, { timeout: 10000 });
        const legacyDates = (legacyRes.data.dates || [])
          .filter(d => d.has_dep_graph)
          .map(d => toIso(d.date))
          .filter(d => d < MONGO_CUTOFF);

        // MongoDB 后端：返回 YYYY-MM-DD，只取 >= 2026-04-01 的日期
        let mongoDates = [];

        try {
          const mongoRes = await axios.get(`${AUTHDEP_MONGO_API}/available-dates`, { timeout: 10000 });

          mongoDates = (mongoRes.data.dates || [])
            .filter(d => d.has_dep_graph && d.date >= MONGO_CUTOFF)
            .map(d => d.date);
        } catch (e) {
          console.warn("[traceback] mongo available-dates 加载失败", e.message);
        }

        this.availableDates = [...new Set([...legacyDates, ...mongoDates])].sort().reverse();

        // 默认选中最新可用日期（不是当天）。仅当用户尚未手动选时填充。
        if (!this.traceDate && this.availableDates.length) {
          this.traceDate = this.availableDates[0];
        }
      } catch (e) {
        console.warn("[traceback] available-dates 加载失败", e.message);
      }
    }
  },
  beforeDestroy() {
    if (this.pieChartInstance) {
      this.pieChartInstance.dispose();
    }
    if (this.queryDepChartInstance) {
      this.queryDepChartInstance.dispose();
    }
    if (this.traceChartInstance) {
      this.traceChartInstance.dispose();
    }
    if (this.keyDepsChartInstance) {
      this.keyDepsChartInstance.dispose();
    }
  }
};
</script>

<style scoped lang="less">
.authdep-container {
  min-height: var(--screen-height, 100vh);
  height: var(--screen-height, 100vh);
  background: #0a1628;
  color: #C1D5FF;
  padding-bottom: 90px;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  text-align: left;

  .leftSider {
    position: fixed; left: 0; top: 0; height: 100%; z-index: 1; pointer-events: none;
    img { height: 100%; }
  }
  .rightSider {
    position: fixed; right: 0; top: 0; height: 100%; z-index: 1; pointer-events: none;
    img { height: 100%; }
  }
}

.sub-tabs {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 12px 0 0;
  position: relative;
  z-index: 2;

  .sub-tab-item {
    padding: 8px 28px;
    border-radius: 6px 6px 0 0;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    color: #7a9cc8;
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.1);
    border-bottom: none;
    transition: all 0.2s;

    &.active {
      color: #fff;
      background: rgba(59, 130, 246, 0.25);
      border-color: #3b82f6;
    }
    &:hover:not(.active) {
      color: #C1D5FF;
      background: rgba(255,255,255,0.08);
    }
  }
}

.main-content {
  position: relative;
  z-index: 2;
  padding: 0 20px 20px;
}

.tab-panel {
  animation: fadeIn 0.2s ease;
}
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

.section-card {
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.card-title {
  font-size: 15px;
  font-weight: 700;
  color: #e2eeff;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255,255,255,0.08);
}

// 风险态势
.filter-bar {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;

  .filter-group {
    display: flex;
    align-items: center;
    gap: 8px;
    .filter-label { font-size: 13px; color: #7a9cc8; white-space: nowrap; }
  }
  .scan-time {
    margin-left: auto;
    font-size: 13px;
    color: #7a9cc8;
    .highlight { color: #e2eeff; font-weight: 600; }
  }
}

.dashboard-panels {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 16px;
  align-items: stretch;
}

.panel-card {
  display: flex;
  flex-direction: column;
  .metric-number { font-size: 32px; font-weight: 700; color: #3b82f6; text-align: center; }
  .metric-label { font-size: 13px; color: #7a9cc8; text-align: center; margin-bottom: 8px; }
  .chart-container { height: 200px; }
  .chart-caption { font-size: 12px; color: #7a9cc8; text-align: center; margin-top: 8px; }
  .dep-depth-label { font-size: 13px; color: #7a9cc8; margin-bottom: 4px; }
  .dep-depth-number { font-size: 32px; font-weight: 700; color: #3b82f6; }
  .dep-depth-sub { font-size: 12px; color: #7a9cc8; margin-bottom: 12px; }
  .dep-table-title { font-size: 13px; font-weight: 600; color: #C1D5FF; margin-bottom: 8px; flex: 0 0 auto; }
  .dep-table { flex: 0 0 auto; }
}

.risk-category-label {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #C1D5FF;
  margin: 14px 0 8px;
  padding-bottom: 7px;
  border-bottom: 1px solid rgba(24,144,255,0.25);
}

.risk-category-divider {
  margin: 12px 0;
}

  .risk-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 0;
  border-bottom: 1px solid rgba(255,255,255,0.05);
  &:last-child { border-bottom: none; }

  .risk-row-left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    flex: 1;
    min-width: 0;
    padding-right: 18px;
    .risk-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }
    .risk-type {
      font-size: 19px;
      color: rgba(255,255,255,0.75);
      font-family: 'Microsoft YaHei', sans-serif;
    }
    .risk-detail {
      font-size: 14px;
      line-height: 1.7;
      color: rgba(193,213,255,0.68);
      font-family: 'Microsoft YaHei', sans-serif;
    }
  }

  .risk-row-right {
    display: flex;
    gap: 16px;
    .risk-stat {
      display: flex;
      flex-direction: row;
      align-items: baseline;
      gap: 4px;
      min-width: 70px;
      .risk-count {
        font-size: 26px;
        font-weight: 700;
        color: #fff;
        line-height: 1;
        font-family: 'Microsoft YaHei', sans-serif;
      }
      .risk-label {
        font-size: 12px;
        color: #4a6a8a;
        font-family: 'Microsoft YaHei', sans-serif;
      }
    }
  }
}


.domain-link {
  color: #60a5fa;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.15s;
  &:hover {
    color: #93c5fd;
    text-decoration: underline;
  }
}
.risk-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px;
  background: rgba(239,68,68,0.15);
  color: #f87171;
  font-size: 12px;
  margin-right: 4px;
  margin-bottom: 2px;
}
.status-badge {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  margin-right: 4px;
  &.active { background: rgba(34,197,94,0.15); color: #4ade80; }
  &.inactive { background: rgba(255,255,255,0.06); color: #7a9cc8; }
}

.risk-case-filter-bar {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) 110px 150px 130px auto auto;
  gap: 10px;
  align-items: center;
  margin-bottom: 12px;
}
.risk-case-search { min-width: 0; }
.risk-case-count {
  justify-self: end;
  color: #7a9cc8;
  font-size: 12px;
  white-space: nowrap;
}
.risk-case-pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-height: 42px;
  margin-top: 10px;
}

.severity-badge {
  display: inline-block;
  min-width: 34px;
  padding: 2px 8px;
  border-radius: 10px;
  text-align: center;
  font-weight: 700;
  font-size: 12px;
}
.severity-p0 { background: rgba(239,68,68,0.2); color: #f87171; }
.severity-p1 { background: rgba(249,115,22,0.18); color: #fb923c; }
.severity-p2 { background: rgba(234,179,8,0.16); color: #facc15; }
.severity-p3 { background: rgba(96,165,250,0.16); color: #93c5fd; }
.risk-case-detail {
  display: grid;
  grid-template-columns: minmax(240px, 1.3fr) minmax(240px, 1fr) minmax(160px, 0.8fr);
  gap: 14px;
  padding: 12px 18px;
  background: rgba(15, 23, 42, 0.45);
}
// 修复展开行默认白底白字：覆盖 Element UI .el-table__expanded-cell
/deep/ .risk-cases-table .el-table__expanded-cell {
  background: #0f1f3a !important;
  color: #C1D5FF;
  padding: 0;
  &:hover {
    background: #0f1f3a !important;
  }
}
/deep/ .risk-cases-table .el-table__row--level-0 + tr .el-table__expanded-cell {
  background: #0f1f3a !important;
}
.detail-title { color: #C1D5FF; font-weight: 600; margin-bottom: 6px; }
.detail-title.sub { margin-top: 10px; color: #93b4ec; }
.detail-line { color: #9DB7E8; line-height: 1.7; }
.detail-line.muted { color: #6f86b5; }
.detail-block.compact { min-width: 0; }

@media (max-width: 1080px) {
  .risk-case-filter-bar {
    grid-template-columns: minmax(180px, 1fr) 1fr 1fr;
  }
  .risk-case-count {
    justify-self: start;
  }
}

// 风险查询
.query-layout {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}
.query-main { flex: 1; min-width: 0; }

.search-bar {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  .search-input { flex: 1; }
}

.dep-graph-panel {
  margin-top: 16px;
  .dep-graph-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    .dep-graph-time { font-size: 12px; color: #7a9cc8; }
  }
  .dep-graph-container { height: 400px; background: rgba(0,0,0,0.2); border-radius: 6px; }
  .dep-graph-legend {
    display: flex;
    gap: 16px;
    margin-top: 12px;
    font-size: 12px;
    color: #7a9cc8;
  }
}

// query-table 展开行：复用风险案例详情视觉
/deep/ .query-table .el-table__expanded-cell {
  background: #0f1f3a !important;
  color: #C1D5FF;
  padding: 0;
  &:hover { background: #0f1f3a !important; }
}
.query-row-detail { padding: 14px 18px; }
.query-row-detail .risk-case-detail { padding: 0 0 12px 0; background: transparent; }
.dep-graph-panel-inline {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(255,255,255,0.06);
  .dep-graph-header {
    display: flex; justify-content: space-between; align-items: center;
    margin-bottom: 12px;
    .card-title { font-size: 14px; }
    .dep-graph-time { font-size: 12px; color: #7a9cc8; }
  }
  .dep-graph-container { height: 360px; background: rgba(0,0,0,0.2); border-radius: 6px; }
  .dep-graph-legend {
    display: flex; gap: 16px; margin-top: 12px; font-size: 12px; color: #7a9cc8;
  }
  .dep-hint { padding: 32px 0; text-align: center; color: #7a9cc8; font-size: 13px; }
}

// 三状态徽标：红 / 绿 / 灰
.state-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-right: 6px;
}
.state-badge.state-has_risk { background: rgba(239,68,68,0.18); color: #fca5a5; border: 1px solid rgba(239,68,68,0.4); }
.state-badge.state-no_risk { background: rgba(34,197,94,0.18); color: #86efac; border: 1px solid rgba(34,197,94,0.4); }
.state-badge.state-not_probed { background: rgba(148,163,184,0.16); color: #cbd5e1; border: 1px solid rgba(148,163,184,0.35); }
.state-badge.state-loading { background: rgba(96,165,250,0.16); color: #93c5fd; border: 1px solid rgba(96,165,250,0.35); }

.state-banner {
  padding: 10px 14px;
  border-radius: 6px;
  font-size: 13px;
  margin-bottom: 6px;
}
.state-banner.state-no-risk { background: rgba(34,197,94,0.10); color: #86efac; border-left: 3px solid #22c55e; }
.state-banner.state-not-probed { background: rgba(148,163,184,0.10); color: #cbd5e1; border-left: 3px solid #94a3b8; }

.company-tag {
  display: inline-block;
  padding: 1px 8px;
  margin: 2px 4px 2px 0;
  border-radius: 10px;
  font-size: 11px;
  background: rgba(96,165,250,0.14);
  color: #bfdbfe;
  border: 1px solid rgba(96,165,250,0.3);
}
.muted { color: #6f86b5; font-size: 12px; }

// 状态回溯
.time-picker-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(59,130,246,0.08);
  border: 1px solid rgba(59,130,246,0.2);
  border-radius: 8px;
  padding: 12px 20px;
  margin-bottom: 16px;
  .time-icon { font-size: 32px; color: #3b82f6; }
  .time-picker-label { font-size: 12px; color: #7a9cc8; margin-bottom: 4px; }
}

.trace-graph-section {
  .trace-graph-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    .trace-graph-controls { display: flex; gap: 8px; align-items: center; }
  }
  .trace-legend-bar {
    display: flex;
    gap: 20px;
    background: rgba(255,255,255,0.04);
    border-radius: 6px;
    padding: 10px 16px;
    margin-bottom: 12px;
    font-size: 12px;
  }
  .trace-graph-container { height: 500px; background: rgba(0,0,0,0.2); border-radius: 6px; }
  .trace-legend-detail {
    display: flex;
    gap: 40px;
    margin-top: 16px;
    font-size: 12px;
    color: #7a9cc8;
    .legend-detail-title { font-weight: 600; color: #C1D5FF; margin-bottom: 6px; }
  }
}

// 通用图例
.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #7a9cc8;
}
.legend-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }
.passive-dot { background: #f9a8d4; }
.auth-dot { background: #4ade80; }
.record-dot { background: #fdba74; }
.legend-box { width: 14px; height: 14px; border-radius: 3px; border: 2px solid; flex-shrink: 0; }
.risk-box { background: rgba(239,68,68,0.1); border-color: #ef4444; }
.normal-box { background: rgba(59,130,246,0.1); border-color: #3b82f6; }
.warn-box { background: rgba(245,158,11,0.1); border-color: #f59e0b; }
.legend-line { display: inline-block; width: 32px; height: 2px; flex-shrink: 0; }
.solid-line { background: #94a3b8; }
.dashed-line { border-top: 2px dashed #94a3b8; background: transparent; }
.green-line { border-top-color: #4ade80; }
.risk-line { border-top-color: #ef4444; }

/deep/ .navigation {
  text-align: center;
  .nav-item { text-align: center; }
}

// ===== Element UI 全局暗色覆盖 =====
/deep/ .el-table {
  background: transparent;
  color: #C1D5FF;

  th {
    background: rgba(24, 144, 255, 0.1);
    color: #fff;
    font-weight: bold;
    border-color: rgba(255, 255, 255, 0.1);
  }
  td {
    border-color: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.85);
  }
  tr {
    background: transparent;
    &:hover > td {
      background: rgba(24, 144, 255, 0.1) !important;
      cursor: pointer;
    }
  }
  &::before { display: none; }
  .el-table__header-wrapper,
  .el-table__body-wrapper { width: 100% !important; }
  .el-table__header,
  .el-table__body { width: 100% !important; }
  .cell { white-space: normal; word-break: break-word; }
}

/deep/ .el-input__inner {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.15);
  color: #C1D5FF;
  &::placeholder { color: rgba(193, 213, 255, 0.4); }
  &:focus {
    border-color: #1890ff;
    background: rgba(24, 144, 255, 0.08);
  }
}

/deep/ .el-select {
  .el-input__inner { background: rgba(255,255,255,0.06); border-color: rgba(255,255,255,0.15); color: #C1D5FF; }
  .el-input__suffix .el-icon-arrow-up { color: #7a9cc8; }
}

/deep/ .el-select-dropdown {
  background: #0f2040;
  border-color: rgba(255,255,255,0.15);
  .el-select-dropdown__item {
    color: #C1D5FF;
    &:hover, &.hover { background: rgba(24,144,255,0.15); }
    &.selected { color: #1890ff; }
  }
}

/deep/ .el-checkbox {
  color: #C1D5FF;
  .el-checkbox__inner {
    background: rgba(255,255,255,0.06);
    border-color: rgba(255,255,255,0.25);
  }
  &.is-checked .el-checkbox__inner {
    background: #1890ff;
    border-color: #1890ff;
  }
}

/deep/ .el-date-editor {
  .el-input__inner {
    background: rgba(255,255,255,0.06);
    border-color: rgba(255,255,255,0.15);
    color: #C1D5FF;
  }
  .el-input__prefix, .el-input__suffix { color: #7a9cc8; }
}

/deep/ .el-button {
  &--primary {
    background: #1890ff;
    border-color: #1890ff;
    &:hover { background: #40a9ff; border-color: #40a9ff; }
  }
  &--default {
    background: rgba(255,255,255,0.06);
    border-color: rgba(255,255,255,0.2);
    color: #C1D5FF;
    &:hover { background: rgba(255,255,255,0.12); border-color: rgba(255,255,255,0.3); color: #fff; }
  }
  &--text { color: #60a5fa; &:hover { color: #93c5fd; } }
}

// 授权依赖信息看板 新增样式
.dep-table-filter-hint {
  font-size: 11px;
  font-weight: 400;
  color: #4a6a8a;
  margin-left: 4px;
}
.dep-hint {
  font-size: 12px;
  color: #4a6a8a;
  padding: 8px 0 4px;
  text-align: center;
}

// ===== 关键依赖节点 力导气泡图 =====
.key-deps-chart {
  width: 100%;
  flex: 1 1 0;
  min-height: 0;
  background: rgba(15, 23, 42, 0.25);
  border-radius: 6px;
  margin-top: 4px;
}

// 当前选中列表行高亮
/deep/ .list-row-active > td {
  background: rgba(59, 130, 246, 0.14) !important;
  color: #fff !important;
}

/deep/ .el-table__body-wrapper {
  &::-webkit-scrollbar { width: 6px; height: 6px; }
  &::-webkit-scrollbar-track { background: rgba(255,255,255,0.05); border-radius: 3px; }
  &::-webkit-scrollbar-thumb {
    background: rgba(24,144,255,0.3); border-radius: 3px;
    &:hover { background: rgba(24,144,255,0.5); }
  }
}
.loading-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  .loading-content { display: flex; flex-direction: column; align-items: center; gap: 20px; }
  .loading-dots {
    display: flex; gap: 20px;
    span {
      width: 16px; height: 16px; border-radius: 50%;
      background: #1890FF;
      animation: bounce 1.2s infinite ease-in-out;
      &:nth-child(2) { animation-delay: 0.2s; }
      &:nth-child(3) { animation-delay: 0.4s; }
    }
  }
  .loading-text {
    font-size: 20px; color: #1890FF; letter-spacing: 2px;
    font-family: monospace; min-width: 300px; text-align: center;
    animation: fadeSwitch 0.4s ease;
  }
}
@keyframes bounce {
  0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
  40% { transform: scale(1.2); opacity: 1; }
}
@keyframes fadeSwitch {
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
}

// ===== 授权依赖风险看板 卡片样式（仿 AuthRisk 统计卡片）=====
.risk-stats-cards-container {
  display: flex;
  flex-direction: column;
  gap: 0;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar { width: 6px; }
  &::-webkit-scrollbar-track { background: rgba(255,255,255,0.05); border-radius: 3px; }
  &::-webkit-scrollbar-thumb {
    background: rgba(24,144,255,0.3); border-radius: 3px;
    &:hover { background: rgba(24,144,255,0.5); }
  }
}

.risk-stats-group-wrapper {
  display: contents;
}

.risk-stats-category-divider {
  height: 1px;
  background: rgba(255,255,255,0.07);
  margin: 8px 0;
}

.risk-stats-category-label {
  font-size: 12px;
  font-weight: 600;
  color: #7a9cc8;
  letter-spacing: 0.5px;
  padding: 6px 0 4px;
  text-transform: uppercase;
}

.risk-stats-card-item {
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 8px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 6px;
  transition: all 0.25s ease;
  cursor: default;
  position: relative;
  overflow: hidden;
  min-height: 64px;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0;
    width: 4px; height: 100%;
    transition: all 0.25s ease;
  }

  &:hover {
    transform: translateX(4px);
    box-shadow: 0 3px 12px rgba(0,0,0,0.25);
  }

  &.risk-group-takeover {
    &::before { background: #ef4444; }
    &:hover { border-color: rgba(239,68,68,0.4); background: rgba(239,68,68,0.06); }
    .risk-stats-icon { background: rgba(239,68,68,0.18); color: #ef4444; }
    .risk-stats-badge { background: rgba(239,68,68,0.15); color: #f87171; border-color: rgba(239,68,68,0.3); }
  }
  &.risk-group-dos {
    &::before { background: #f97316; }
    &:hover { border-color: rgba(249,115,22,0.4); background: rgba(249,115,22,0.06); }
    .risk-stats-icon { background: rgba(249,115,22,0.18); color: #f97316; }
    .risk-stats-badge { background: rgba(249,115,22,0.15); color: #fb923c; border-color: rgba(249,115,22,0.3); }
  }
  &.risk-group-ns {
    &::before { background: #FAAD14; }
    &:hover { border-color: rgba(250,173,20,0.4); background: rgba(250,173,20,0.06); }
    .risk-stats-icon { background: rgba(250,173,20,0.18); color: #FAAD14; }
    .risk-stats-badge { background: rgba(250,173,20,0.15); color: #fbbf24; border-color: rgba(250,173,20,0.3); }
  }
  &.risk-group-other {
    &::before { background: #1890ff; }
    &:hover { border-color: rgba(24,144,255,0.4); background: rgba(24,144,255,0.06); }
    .risk-stats-icon { background: rgba(24,144,255,0.18); color: #1890ff; }
    .risk-stats-badge { background: rgba(24,144,255,0.15); color: #60a5fa; border-color: rgba(24,144,255,0.3); }
  }
}

.risk-stats-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
}

.risk-stats-icon {
  width: 36px; height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
}

.risk-stats-name {
  font-size: 14px;
  color: rgba(255,255,255,0.85);
  font-weight: 500;
  line-height: 1.3;
  cursor: default;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.risk-stats-card-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.risk-stats-count-wrapper {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.risk-stats-count {
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  line-height: 1;
  font-family: 'DIN Alternate', 'Microsoft YaHei', sans-serif;
}

.risk-stats-unit {
  font-size: 12px;
  color: #4a6a8a;
}

.risk-stats-badge {
  padding: 3px 10px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  border: 1px solid transparent;
}
.kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
  margin-bottom: 6px;
  .kpi-item {
    min-width: 0;
    background: rgba(96,165,250,0.055);
    border: 1px solid rgba(96,165,250,0.16);
    border-radius: 6px;
    padding: 11px 6px 10px;
    text-align: center;
    .kpi-value {
      font-size: 22px;
      font-weight: 700;
      color: #e2eeff;
      line-height: 1.1;
      font-family: 'DIN Alternate', 'Microsoft YaHei', sans-serif;
    }
    .kpi-label {
      font-size: 12px;
      color: rgba(193,213,255,0.72);
      margin-top: 6px;
      line-height: 1.25;
      white-space: nowrap;
    }
  }
}
.kpi-divider {
  height: 1px;
  background: rgba(255,255,255,0.07);
  margin: 12px 0;
}
/deep/ .el-tag--success { background: rgba(34,197,94,0.15); border-color: rgba(34,197,94,0.3); color: #4ade80; }
/deep/ .el-tag--warning { background: rgba(245,158,11,0.15); border-color: rgba(245,158,11,0.3); color: #fbbf24; }
/deep/ .el-tag--danger  { background: rgba(239,68,68,0.15);  border-color: rgba(239,68,68,0.3);  color: #f87171; }
/deep/ .el-tag--info    { background: rgba(148,163,184,0.1); border-color: rgba(148,163,184,0.2); color: #94a3b8; }
/deep/ .el-tag          { background: rgba(59,130,246,0.15); border-color: rgba(59,130,246,0.3);  color: #60a5fa; }
.beian-footer {
  margin: 32px 0 72px;
  text-align: center;
  color: #8a99aa;
  font-size: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.beian-footer a {
  color: #8a99aa;
  text-decoration: none;
}

.beian-footer a:hover {
  color: #409eff;
}

.beian-police-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.beian-police-logo {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

</style>
